/* globals isClient */

import c from 'state/constants'
import {findKey} from 'lodash/object'
import ga from 'react-ga'
import {formatDate, serverDateFormat, trimObject} from 'lib/helpers'
import {hasErrors, apiCall, transactionCall} from './api'
import json2csv from 'json2csv'
import FileSaver from 'file-saver'
import cs from 'classnames'
import moment from 'moment'
import underscore, { result } from 'underscore'
import lodash from 'lodash'
import nesProp from 'nested-property'
import signatureGenerator, {replacePlaceholderToTransparentLogo, generateSignatureReplaceData,
    generateUniqueHashFromSignatureData, replacePlaceholderToNothing} from 'components/office/signatureGenerator'
import {getPromiseForTranslations} from 'lib/i18n'
import i18n from 'lib/i18n'
import uuidv4 from 'uuid/v4';
import Cookies from 'js-cookie';
import {UPLOADER_STATE_NEW_POLICY, UPLOADER_STATE_POLICY_FILE, UPLOADER_STATE_POLICY_FILE_ID,
    UPLOADER_STATE_NEW_POLICY_ID} from 'state/constants'

const translate = i18n('')
const STALE_TIME = 5 * 60 * 1000

export const setNotification = (msg, nType) => ({
	type: c.NOTIFICATION_SET,
	msg, nType,
})

export const disableBackgroundProcesses = (backgroundProcessesDisabled) => ({
	type: c.DISABLE_BACKGROUND_PROCESSES,
	backgroundProcessesDisabled,
})

export const clearNotification = () => ({
	type: c.NOTIFICATION_CLEAR,
})

export const checkIfIE = () => dispatch => {
	const isIE = Boolean(global.document && global.document.documentMode)
	dispatch({type: c.SET_IS_IE, isIE})
}

export const gotContacts = (contacts) => ({type: c.FETCHED_CONTACTS, contacts})

const formatContact = (contact) => {
	Object.keys(contact).forEach((index) => {
		if (contact[index] === null) {
			(contact)[index] = ""
		}
	})
	return ({
		...contact,
		original: JSON.stringify(contact),
		address: contact.street && contact.houseNum && (contact.zip || contact.city) ? `${contact.street} ${contact.houseNum}, ${contact.zip} ${contact.city}` : '',
		birthday: contact.birthday ? formatDate(contact.birthday, 'eu') : '',
		phone: contact.phone,
		email: contact.email,
	})
}
export const loadContacts = () => dispatch => (
	dispatch(apiCall('/api/getContacts'))
	.then((data) => dispatch(gotContacts(data.map(formatContact))))
)

export const setContact = (data) => dispatch => (
	dispatch(apiCall(`/api/contact/${data._id || ''}`, {data}))
	.then(() => dispatch(loadContacts()))
	.catch(() => dispatch(setNotification('Could not save the contact!', 'error')))
)

export const showContactModal = id => ({
	type: c.SHOW_CONTACT_MODAL,
	id,
})

export const hideContactModal = () => ({
	type: c.HIDE_CONTACT_MODAL,
})

export const zoomContact = (id) => ({
	type: c.ZOOM_CONTACT,
	id,
})

export const closeContact = () => ({
	type: c.CLOSE_CONTACT,
})

export const removeContactById = id => dispatch => (
	dispatch(apiCall(`/api/delContact/${id}`, {method: 'POST'}))
	.then(() => dispatch(loadContacts()))
	.catch(err => console.warn(err))
)

export const setLang = lang => (
	dispatch => {
		if (lang) {
			localStorage.setItem('clientLanguage', lang)
		} else {
			lang = localStorage.getItem('clientLanguage') || 'nl'
		}
		global.lang = lang
		dispatch({
			type: c.LANG_SET,
			lang,
		})
	}
)

export const acceptCookies = () => (
	(dispatch, getState) => {
		const {cookiesAccepted} = getState().auth

		if(!cookiesAccepted) {
			Cookies.set('cookiesAccepted', process.env.COOKIE_VERSION, { expires: 365 });
			dispatch({type: c.COOKIES_ACCEPTED})
		}

		return true
	}
)

export const validateCookie = () => {
	return (dispatch, getState) => {
		const { cookiesAccepted } = getState().auth

		if(cookiesAccepted) {
			const cookie = Cookies.get('cookiesAccepted')
			const cookieVersion = process.env.COOKIE_VERSION

			if (cookie !== cookieVersion) {
				dispatch(cleanCookies())
			}
		}

		return true
	}
}

export const cleanCookies = () => ({
	type: c.COOKIES_CLEAN
})

export const setAppParam = (param) => ({
	type: c.SET_APP_PARAM,
	param,
})

const setAppData = (data) => {
	return {
		type: c.APP_CHANGED,
		data,
	}
}

export const setNews = (items, lastLoginTime) => ({
	type: c.GOT_NEWS,
	items,
	ts: Date.now(),
	lastLogin: lastLoginTime
})

export const getNews = () => (dispatch, getState) => {
	const {news: {ts}, app: {lang}} = getState()
	let newsList = null
	if (!ts || (Date.now() - ts > STALE_TIME)) {
		return dispatch(apiCall('/api/getNews', {lang}))
		.then(
			news =>{
				newsList = news
				return dispatch(getLoginRecord())
			},
			// Ignore errors
			() => dispatch(setNews([])),
		).then(res => {
			return dispatch(setNews(newsList, res.lastLoginTime))
		})
	}
	return Promise.resolve()
}

export const selectNews = (itemId) => ({
	type: c.NEWS_SELECT,
	itemId,
})

export const setFlash = (items) => ({
	type: c.GOT_FLASH,
	items,
	ts: Date.now(),
})

export const getFlash = (force = false) => (dispatch, getState) => {
	const {flash: {ts}, app: {lang}} = getState()
	if (force || !ts || (Date.now() - ts > STALE_TIME)) {
		return dispatch(apiCall('/api/getFlashes', {lang}))
		.then(
			flash => dispatch(setFlash(flash)),
			// Ignore errors
			() => dispatch(setFlash([])),
		)
	}
	return Promise.resolve()
}

export const setOpened = (itemId) => ({
	type: c.ITEM_ZOOMED,
	itemId,
})

export const setOpenedSubmenu = (itemId, initialArguments = null) => ({
	type: c.SUBMENU_ITEM_ZOOMED,
    itemId,
    initialArguments
})

export const setBrNr = (brNr) => ({
	type: c.BRNR_USED,
	brNr,
})

export const removeNewsZoom = () => ({
	type: c.NEWS_ZOOM_CLOSED,
})

export const setNewsFilter = (filter) => ({
	type: c.NEWS_FILTERED,
	filter,
})

export const setNewLoaded = (filter) => ({
	type: c.NEWS_LOADED
})

export const setFaq = (items) => ({
	type: c.GOT_FAQ,
	items,
	ts: Date.now(),
})

export const getFaq = () => (dispatch, getState) => {
	const {faq: {ts}, app: {lang}} = getState()
	if (!ts || (Date.now() - ts > STALE_TIME)) {
		return dispatch(apiCall('/api/getFaqs', {lang}))
		.then(
			faq => dispatch(setFaq(faq)),
			// Ignore errors
			() => dispatch(setFaq([])),
		)
	}
	return Promise.resolve()
}

export const setFaqFilter = (filter) => ({
	type: c.FAQ_FILTERED,
	filter,
})

export const setLinks = (items) => ({
	type: c.GOT_LINKS,
	items,
	ts: Date.now(),
})

export const getLinks = () => (dispatch, getState) => {
	const {links: {ts}, app: {lang}} = getState()
	if (!ts || (Date.now() - ts > STALE_TIME)) {
		return dispatch(apiCall('/api/getLinks', {lang}))
		.then(
			links => dispatch(setLinks(links)),
			// Ignore errors
			() => dispatch(setLinks([])),
		)
	}
	return Promise.resolve()
}

export const setLinksFilter = (filter) => ({
	type: c.LINKS_FILTERED,
	filter,
})

export const setAppModule = (module, id, search) => ({
	type: c.SET_APP_MODULE,
	module,
	id,
	search,
})

export const setCustomDsDocumentsModule = (module, preSortDocumentsFromClient, id = '') => ({
	type: c.SET_APP_MODULE,
	module,
	preSortDocumentsFromClient,
	id
})

export const toggleMenu = (state) => ({
	type: c.TOGGLE_MENU,
	state,
})

export const toggleSubMenu = (state) => ({
	type: c.TOGGLE_SUB_MENU,
	state
})


const loggedOut = () => ({
	type: c.LOGGED_OUT,
})

export const changeAuthState = (authState, options) => ({
	type: c.AUTH_STATE_CHANGED,
	authState,
	options,
})

export function setInbox(data) {
	return {
		type: c.GOT_INBOX,
		data,
		ts: Date.now(),
	}
}

export const getUnreadTicketsNum = () => dispatch => (
	dispatch(apiCall('/api/getTicketsUnreadNum', {noLoader: true}))
	.then(number => dispatch({type: c.SET_UNREAD_NUM, number}))
)
export const getInbox = (force) => (dispatch, getState) => {
	const {ts} = getState().inbox
	if (force || (!ts || (Date.now() - ts > STALE_TIME))) {
		return dispatch(getDsDocsAndPackages())
		.then(() => {
			return dispatch(apiCall('/api/getTickets'))
			.then(
				inbox => dispatch(setInbox(inbox)),
				// Ignore errors
				() => dispatch(setInbox([])),
			)
		})
	}
	return Promise.resolve()
}
export const updateInbox = () => (dispatch, getState) => {
	if (getState().app.module === c.INBOX) {
		return dispatch(getInbox())
	} else {
		return dispatch(getUnreadTicketsNum())
	}
}


/*************************************************
 * START SECTION OF INTERVAL CHECKING OF INBOX ***
 *************************************************/

// setup global variable to store the timer ID to control the calls
if (!window.unreadTimer) {
    window.unreadTimer = 0
}

/**
 * Function to call to refresh the inbox
 * @param {*} dispatch
 * @param {*} getState
 * @returns
 */
const checkUnread = (dispatch, getState) => {
    // Process blocker check by STORE flag
    // --- originally invented to protect an iframe in DSWizard, to disable rendering origin to avoid refresh
    if (getState().app.backgroundProcessesDisabled) {
        // keep the timer loop alive, restart
        startTimerForInboxRefresh(dispatch, getState)

        // skip other steps, don't call any API
        return Promise.resolve()
    }

    // for logged users call the API, but in case of error stop repeated timer
    // EXIT point
    if (getState().auth.isLoggedIn) {
        // call the AIP
        return dispatch(updateInbox())

        // user session is valid and the request had a valid response
        .then(() => {
            // restart the timer again
            startTimerForInboxRefresh(dispatch, getState)
        })

        // in case of ERROR stop the inbox refresher (mean not authenticated)
        .catch((err) => {
            // stop timer to avoid unnecessary call
            stopTimerForInboxRefresh()
            return err
        })
    }

    // retry to check the login state
    startTimerForInboxRefresh(dispatch, getState)
    return Promise.resolve()
}

/**
 * Stis function start firstly the checking of inbox emails
 * @returns
 */
export const startUnreadChecking = () => (dispatch, getState) => {
    // stop timer to avoid unnecessary call
    stopTimerForInboxRefresh()
    // fire the first call and start timer
    checkUnread(dispatch, getState)
}

/**
 * Set the timer to start the API call
 */
const startTimerForInboxRefresh = (dispatch, getState) => {
    // stop timer to avoid unnecessary call
    stopTimerForInboxRefresh()
    window.unreadTimer = setTimeout(checkUnread, 60000, dispatch, getState)
}

/**
 * Clear timer to stop calling the API
 * @returns
 */
export const stopTimerForInboxRefresh = () => dispatch => { // eslint-disable-line no-unused-vars
	if (window.unreadTimer) {
		clearTimeout(window.unreadTimer)
		window.unreadTimer = undefined
	}
}
/***************************************
 * END OF INTERVAL CHECKING OF INBOX ***
 ***************************************/

export const navigateToDsDocumentFromTicket = (documentId, module, currentModule) => (dispatch) => {
	return dispatch(
		{
			type: c.NAVIGATE_TO_DSDOCUMENT,
			module,
			name: 'detailedDSDocument',
			itemId: documentId,
			currentModule
		}
	)
}

export const logout = () => dispatch => {
	if (!isClient) {
		dispatch(stopTimerForInboxRefresh())
	}
	const gone = () => dispatch(loggedOut())
	dispatch(apiCall('/auth/logout'))
	.then(gone, gone)
}

export const filterTicket = (selectValue) => ({
	type: c.SET_FILTERED,
	selectValue,
})


/************************************************************
 * Actions for OUTBOX
 ************************************************************/
export function setOutbox(data) {
	return {
		type: c.GOT_OUTBOX,
		data,
		ts: Date.now(),
	}
}
export const getOutbox = (force) => (dispatch, getState) => {
	const {ts} = getState().outbox
	if (force || (!ts || (Date.now() - ts > STALE_TIME))) {
		return dispatch(apiCall('/api/getEmails'))
		.then(
			inbox => dispatch(setOutbox(inbox)),
			// Ignore errors
			() => dispatch(setOutbox([])),
		)
	}
	return Promise.resolve()
}
export const updateOutbox = () => (dispatch, getState) => {
	if (getState().app.module === c.OUTBOX) {
		dispatch(getOutbox())
	}
}
export const filterOutbox = (selectValue=null, startDate=null, endDate=null) => ({
	type: c.OUTBOX_SET_FILTERED,
	selectValue,
	startDate,
	endDate,
})
const _archiveEmails = (itemIds, dispatch) => {
        return dispatch(apiCall('/api/updateEmails', {data:{
            emailIds: itemIds,
            attributes: {archived: true}
        }}))
        .then(() => dispatch(getOutbox(true)))
}
export const archiveEmail = (items) => (dispatch) => {
    const itemIds = items.filter(i => i.checked === true).map(i => i.id)
	return _archiveEmails(itemIds, dispatch)
}
export const archiveAllEmail = (items) => (dispatch) => {
	const itemIds = items && items.map(i => i.id) || []
	return _archiveEmails(itemIds, dispatch)
}
export const setOutboxEmailOpened = (itemId) => ({
	type: c.OUTBOX_ITEM_ZOOMED,
	itemId,
})
export const setOutboxSubModule = (name, subModuleZoom) => ({
	type: c.SET_OUTBOX_SUB_MODULE,
	name,
	subModuleZoom,
})
export const setSeenOutboxEmail = (itemId) => (dispatch) => {
    return dispatch(apiCall('/api/updateEmails', {data: {
        emailIds: [itemId],
        attributes: {seenInOutbox: true}
    }}))
    .then(() => dispatch(getOutbox(true)))
}
export const syncEmailPdf = (emailId) => (dispatch) => {
    return dispatch(apiCall('/syncEmailPdf', {data: {
        emailId: emailId
    }}))
}
/************************************************************
 * End of OUTBOX actions
 ************************************************************/

/************************************************************
 * Actions for emailSender
 ************************************************************/

export const getEmailTemplate = (moduleKey) => (
    (dispatch) => dispatch(apiCall(`/api/getEmailTemplates`, {data: {moduleKey}}))
	.catch(() => dispatch(setNotification('Could not fetch the email templates!', 'error')))
)

// Get templates only for invitation
export const getInvitationTemplates = (moduleKey, packageId) => (
    (dispatch) => dispatch(apiCall(`/api/getInvitationTemplates`, {data: {moduleKey, packageId}}))
	.catch(() => dispatch(setNotification('Could not fetch the invitation email templates!', 'error')))
)


/**
 * Preset module to load templates.
 * @param {*} moduleKey used to init the correct templates and related with module
 * @param {*} modalId
  * @returns
 */
export const setEmailSenderModule = (moduleKey, modalId = null) => ({
    type: c.SET_EMAIL_SENDER_MODULE,
    moduleKey,
    modalId
})

/**
 * Pop up the modal when everything is initialised and loaded
 * @returns
 */
export const showEmailSenderModal = () => ({
    type: c.SHOW_EMAIL_SENDER_MODAL
})

export const hideEmailSenderModal = () => ({
	type: c.HIDE_EMAIL_SENDER_MODAL,
})
export const showEmailSenderConfirmationModal = (modalId, title, message, flag, payload) => ({
        type: c.SHOW_EMAIL_SENDER_CONF_MODAL,
        modalId,
        confirmationModal: {
            message,
            title,
            flag,
            payload,
            result: false
        }
})
export const hideEmailSenderConfirmationModal = (modalId, result) => ({
    type: c.HIDE_EMAIL_SENDER_CONF_MODAL,
    modalId,
    result: result
})
export const showEmailSenderAttachmentModal = (modalId, title, message, flag, payload) => ({
        type: c.SHOW_EMAIL_SENDER_ATT_MODAL,
        attachmentModal: {
            modalId,
            message,
            title,
            flag,
            payload,
            result: false
        }
})
/* export const updateModuleOptions = (moduleOptions) => ({
    type: c.EMAIL_SENDER_UPDATE_MODULE_OPTIONS,
    moduleOptions
}) */
export const hideEmailSenderAttachmentModal = (result) => ({
    type: c.HIDE_EMAIL_SENDER_ATT_MODAL,
    result: result
})
export const sendEmailBySender = (email) => (
    (dispatch) => dispatch(apiCall(`/api/sendEmail`, {data: email}))
)

export const getActualizedPackageForInvitation = (packageId) => async (dispatch) => {
	try {
		const actualizedPackage = await dispatch(apiCall('/api/actualizePackageForInvitation', {data: {packageId}}))
		return actualizedPackage
	} catch (error) {
		console.warn(error)
		return error
	}
}

/**
 * This function will open the emailServerConfig modal in case sending email addres server config is missing
 * the senderName parameter BEWB-322
 * @param {*} senderEmailAddress
 * @returns
 */
export const showEmailServerConfigModal = (senderEmailAddress) => ({
	type: c.SHOW_EMAIL_SERVER_CONFIG_MODAL,
	senderEmailAddress
})

export const hideEmailServerConfigModal = (serverConfigIsSaved) => ({
	type: c.HIDE_EMAIL_SERVER_CONFIG_MODAL,
	serverConfigIsSaved
})

/**
 * This function will do the precache of documents for email attachments.
 * @param {object} attachment - {id, typeDocument} - the ID of the oracle document, and the typeDocument
 *   param value if exists
 * @param {bool} noLoader - if true the the spinner will displayed until the response finished
 */
export const preCacheDocuments = (attachment, noLoader=false) => (
    (dispatch) => {

        // prepare typeDocumentParam for precache
        let typeUrlParamString = ''
        if (attachment && attachment.typeDocument) {
            typeUrlParamString = '&type='+attachment.typeDocument
        }

        return dispatch(apiCall(`/data/document?id=${attachment.id}&cacheOnly=1`+typeUrlParamString, {noLoader, noCache: false}))
    }
)

/**
 * This function will precache a bunch of document.
 * @param {object} documents - {id, typeDocument} - the ID of the oracle document, and the typeDocument
 *   param value if exists
 * @param {bool} noLoader - if true the the spinner will displayed until the response finished
 */
export const preCacheDocumentsBulk = (documents, noLoader=false) => (
    (dispatch) => {
        return dispatch(apiCall('/cacheDocuments', {data: {documents}, noLoader: false}))
    }
)


/**
 * set document id to the store for download
 * @param {*} id
 */
export const setEmailDocumentId = (id) => ({
	type: c.SET_EMAIL_DOCUMENT_ID,
	id,
})

export const setEmailSenderExternalAttachments = (externalAttachments) => ({
	type: c.SET_EMAIL_EXTERNAL_ATTACHMENTS,
	externalAttachments,
})
/* END Actions for emailSender
 ************************************************************/

/************************************************************
 * START Actions for EmailRecentRecipients ******************************/

/**
 *
 * @param {*} brokerNumber
 */
export const loadEmailRecentRecipients = (brokerNumber) => dispatch => {
    return dispatch(apiCall('/data/getEmailRecentRecipients',{data: {brokerNumber}, noLoader: false, noCache: true}))
    .then((result) => {
        return result && Array.isArray(result) && result || []
    })
    .catch(() => {dispatch(setNotification('Could not load the recent recipients list!', 'error'))
        return Promise.resolve([])
    })
}

/**
 *
 * @param {*} brokerNumber
 * @param {*} email
 * @param {*} lang
 */
export const addEmailRecentRecipients = (brokerNumber, email, lang) => dispatch => {
    return dispatch(apiCall(`/data/addEmailRecentRecipients`, {data: {brokerNumber, email, lang}, noLoader: false, noCache: true}))
    .then((data) => {
        return data
    })
    .catch(() => dispatch(setNotification('Could not add the recipient to the list of recently used email-addresses!', 'error')))
}

/**
 *
 * @param {*} brokerNumber
 * @param {*} email
 */
export const removeEmailRecentRecipients = (brokerNumber, email) => dispatch => {
    return dispatch(apiCall(`/data/removeEmailRecentRecipients`, {data: {brokerNumber, email}, noLoader: false, noCache: true}))
    .then((data) => {
        return data
    })
    .catch(() => dispatch(setNotification('Could not remove the recipient to the list of recently used email-addresses!', 'error')))
}
/* END Actions for EmailRecentRecipients
 ************************************************************/

/************************************************************
 * START Actions for signature ******************************/

export const gotSignatures = (signatures) => {
    return {type: c.FETCHED_SIGNATURES, signatures}
}

const formatSignature = (signature) => {
	Object.keys(signature).forEach((index) => {
		if (signature[index] === null) {
			(signature)[index] = ""
		}
    })
	return ({
        ...signature,
	})
}
export const loadSignatures = () => dispatch => {
    return dispatch(apiCall('/api/getSignatures',{noLoader: false, noCache: true}))
    .then((data) => {
        return dispatch(gotSignatures(data.map(formatSignature)))
    })
    .catch(() => dispatch(setNotification('Could not refresh the Signature list!', 'error')))
}

export const setSignature = (data) => dispatch => {
	return dispatch(apiCall(`/api/signature/${data._id || ''}`, {data, noLoader: false, noCache: true}))
	.then((data) => {
        return dispatch(loadSignatures()).then(()=>data)
    })
	.catch(() => dispatch(setNotification('Could not save the signature!', 'error')))
}

export const zoomSignature = (id) => ({
	type: c.ZOOM_SIGNATURE,
	id,
})

export const closeSignature = () => ({
	type: c.CLOSE_SIGNATURE,
})

export const removeSignatureById = id => dispatch => (
	dispatch(apiCall(`/api/delSignature/${id}`, {method: 'POST', noLoader: false, noCache: true}))
	.then(() => dispatch(loadSignatures()))
	.catch(err => {
        console.warn(err)
        setNotification('Could not save the signature!', 'error')
    })
)

export const initSignatureAutomaticGenerator = () => (dispatch, getState) => {
    dispatch(fetchOfficeData()).then((response) => {
        dispatch(loadSignatures()).then((response) => {
            const { app, office } = getState()
            const signatures = office.signatures
            const appLanguage = app.lang
            let userFullName = ((app.firstName || "") + " " + (app.lastName || ""))
            userFullName = String(userFullName).trim()
            const promises = []

            if (office.brokers) {
                dispatch({type: c.SHOW_LOADER})
                Object.keys(office.brokers).map((brNr,key) => {
                    let theBroker = office.brokers[brNr]
                    let canBrokerEdit = false
                    let needRegenerate = false
                    let signatureId = null

                    if (!theBroker.main || theBroker.main.modifySignature === undefined) {
                        return
                    }

                    if (theBroker.main.modifySignature === true || theBroker.main.modifySignature === "true") {
                        canBrokerEdit = true
                    }

                    let brokerSignatures = signatures.filter(item => (item.brokerNumber == brNr))
                    const theBrokerName = theBroker.main && theBroker.main.name || ""

                    let replacementData = null
                    let generatedHash = null

                    if (brokerSignatures.length < 1) {
                        needRegenerate = true
                    } else {
                        if (canBrokerEdit === false) {
                            brokerSignatures.map((signature,key) => {
                                if (signature.generatedHash === undefined || signature.generatedHash === null ||
                                    signature.generatedHash == '') {
                                    needRegenerate = true
                                } else {
                                    replacementData = generateSignatureReplaceData(theBroker,app.userId,userFullName, appLanguage)
                                    generatedHash = generateUniqueHashFromSignatureData(replacementData)

                                    if (generatedHash !== signature.generatedHash) {
                                        needRegenerate = true
                                    }
                                }

                                signatureId = signature._id
                            })
                        }
                    }

                    if (needRegenerate === true) {
                        promises.push(new Promise((resolve,reject) => {
                            let theBroker = office.brokers[brNr]
                            signatureGenerator(theBroker, app.userId, userFullName, lang)
                            .then((content) => {
                                let replacementData = generateSignatureReplaceData(theBroker,app.userId,userFullName, appLanguage)
                                let generatedHash = generateUniqueHashFromSignatureData(replacementData)

                                let defaultValues = {
                                    name: "",
                                    content: "",
                                    isDefault: false,
                                    createdAt: "",
                                    updatedAt: "",
                                    generatedHash: "",
                                }

                                defaultValues.name = theBrokerName + " - " + brNr + " (" + moment().format("DD-MM-YYYY HH:mm:ss") + ")"
                                defaultValues.content = content
                                defaultValues.isDefault = true
                                defaultValues.brokerNumber = brNr
                                defaultValues.generatedHash = generatedHash

                                if (signatureId !== null) {
                                    defaultValues._id = signatureId
                                }

                                return defaultValues
                            })
                            .then((signature) => {

                                let canEdit = theBroker && theBroker.main && theBroker.main.modifySignature
                                canEdit = (canEdit === "false" ? false : (canEdit === "true" ? true : !!canEdit))

                                if (signature.content) {
                                    if (canEdit) {
                                        signature.content = replacePlaceholderToTransparentLogo(signature.content)
                                    } else {
                                        signature.content = replacePlaceholderToNothing(signature.content)
                                    }
                                }

                                const newSignature = {
                                    _id: signature._id,
                                    name: signature.name,
                                    content: signature.content,
                                    isDefault: signature.isDefault,
                                    brokerNumber: signature.brokerNumber,
                                    generatedHash: signature.generatedHash
                                }

                                return dispatch(setSignature(newSignature))
                            })
                            .then((response) => {
                                resolve(response)
                            })
                            .catch((error) => {
                                reject(error)
                            })
                        }))
                    }
                })

                if (promises.length < 1) {
                    dispatch({type: c.HIDE_LOADER})
                    return
                }

                Promise.all(promises).then(() => {
                    dispatch({type: c.HIDE_LOADER})
                })
                .catch((error) =>  {
                    dispatch({type: c.HIDE_LOADER})
                })
            }
        })
    })
}

/* END Actions for signature
 ************************************************************/


/************************************************************
 * START Actions for localUpload ******************************/

export const localUploadHandler = (blobInfo, success, failure) => (
    (dispatch, getState) => {
        let xhr, formData
        xhr = new XMLHttpRequest()
        xhr.withCredentials = false

		getPromiseForTranslations().then(()=>{
			xhr.open('POST', 'api/uploadLocal')
			xhr.setRequestHeader('x-csrf-token', translate('csrfclienttoken'))
            xhr.onload = function() {
                let json

                if (xhr.status != 200) {
                    failure('HTTP Error: ' + xhr.status)
                    return
                }

                json = JSON.parse(xhr.responseText)

                if (!json || !json.success || typeof json.success.location != 'string') {
                    failure('Invalid JSON: ' + xhr.responseText)
                    return
                }

                let finalLocation = json.success.location

                if (json.success.location) {
                    let indexOf = json.success.location.indexOf("uploads/localUploads/")
                    if (indexOf != -1) {
                        finalLocation = json.success.location.substring(indexOf)
                        finalLocation = window.location.protocol+'//'+(window.location.href.split("/")[2] + '/' + finalLocation).replace("\/\/", "\/")
                    }
                }

                success(finalLocation)
            }

            formData = new FormData()
            formData.append('type', 'emailImage')
            formData.append('fileName', blobInfo.filename())
            formData.append('comment', "Uploaded from email sender.")
            formData.append('file', blobInfo.blob(), blobInfo.filename())

            xhr.send(formData)
        })
    }
)

/* END Actions for localUpload
 ************************************************************/

export const fetchAgendaData = (noCache) => dispatch =>
	dispatch(apiCall('/api/getEvents', {noCache}))
	.then(response => dispatch({type: c.SET_AGENDA_DATA, response}))
	.catch(() => dispatch(setNotification('Could not fetch the events data!', 'error')))

export const updateSubscribers = (subscriberIds, dateId) => dispatch =>
	dispatch(apiCall('/api/updateSubscr', {data: {subscriberIds, dateId}}))
	.then(() => dispatch(fetchAgendaData(true)))
	.catch(() => dispatch(setNotification('Could not update the subscriber list!', 'error')))

export const fetchUserData = () => dispatch =>
		dispatch(apiCall('/api/getContacts'))
		.then(response => dispatch({type: c.GOT_USERS, response}))

export const setApp = data => (
	function (dispatch) {
		dispatch(setAppData(data))
		if (!isClient) {

			dispatch(startUnreadChecking())

		}
		// Set task list for starting point
		dispatch(taskModuleListGetDefaultColors())
		dispatch(taskModuleListGetUserColors())
		dispatch(taskModuleListGet())
        dispatch(getOutbox())
		dispatch(fetchStaffList())
		dispatch(getNews())

		if (data.tickets) {dispatch(setInbox(data.tickets))}
		if (data.articles) {
			if (data.articles.news) {dispatch(setNews(data.articles.news))}
			if (data.articles.faq) {dispatch(setFaq(data.articles.faq))}
		}
		if (data.links) {dispatch(setLinks(data.links))}

        // wait for translations (if loaded the i18n -> _make)
        if (getPromiseForTranslations) {
            getPromiseForTranslations().then(()=>{
                dispatch(initSignatureAutomaticGenerator())
            })
        } else {
            dispatch(initSignatureAutomaticGenerator())
        }
	}
)

const setClientApp = (data) => (
	(dispatch) => {
		dispatch(setAppData(data))
	}
)

export const areAllSelected = (visibleItems) => ({
	type: c.ARE_SELECTED,
	visibleItems,
})

export function gotFinances(data) {
	return {
		type: c.FETCHED_OFFICE_FINANCES,
		data,
	}
}

export const fetchFinances = (query) => (dispatch, getState) => {
	const {brNr} = getState().app
	return dispatch(apiCall('/data/officeFinances', {data: {
		brokerNumber: brNr,
		startDate: query.startDate ? moment(query.startDate).format("YYYY-MM-DD") : '',
		endDate: query.endDate ? moment(query.endDate).format("YYYY-MM-DD") : '',
		contractNumber: query.contractNumber || '',
		searchParameter: query.type || 'b',
	}}))
    .then(data => {
        // store result
        dispatch(gotFinances(data))
        // promise resolve with response data
        return data
    })
}

export const archive = (items) => (dispatch) => {
	const itemIds = items.filter(i => i.checked === true).map(i => i.id)
	const data = {
		ticketIds: itemIds,
		status: {archived: true},
	}
	return dispatch(apiCall('/api/updateTickets', {data}))
	.then(() => dispatch(getInbox(true)))
}

export const fetchOneTicketById = (ticketId) => (dispatch) => {
	try {
		const ticket =  dispatch(apiCall('/api/getOneTicketById', {data: {ticketId}}))
		return ticket
	} catch (error) {
	return error
	}
}

export const selectItems = (items) => ({
	type: c.SET_ALL_CHECKED,
	items
})

export const deselectItems = () => ({
	type: c.SET_ALL_UNCHECKED
})

export const setTicketUnread = (id, unread) => dispatch => {
	const data = {
		type: c.INBOX_ITEMS_STATUS,
		ticketIds: [id],
		status: {unread},
	}
	return dispatch(apiCall('/api/updateTickets', {
		noLoader: true,
		data,
	}))
	.then(() => dispatch(data))
}

export const setCheckBox = (id) => ({
	type: c.SET_CHECKBOX,
	id,
})

/**
 * Procedure to link a client id to a contract using updateErrorBlocRetour oracle API and update linkedClient
 * @param {*} ticketId
 * @param {*} clientId
 * @param {*} blockretId
 * @returns
 */
export const updateErrorBlocRetour = (ticketId, clientId, blockretId) => dispatch => {
	const data = {ticketId, clientId, blockretId}
	return dispatch(apiCall('/api/updateErrorBlocRetour', {data}))
	.then((res) => {
		dispatch(getInbox(true))
		return res
	}).catch(error => error)
}

/**
 * List of actions used in client profile form
 */
export const initializeProfileForm = (clientData, clientId, formType) =>  {
	return {
        type: c.INITIALIZE_CLIENT_PROFILE_FORM,
        clientData: clientData,
        clientId: clientId,
        formType: formType
    }
}
export const setProfileFormCheckbox = (id , type) => {
	return {
		type: c.SET_PROFILE_FORM_CHECKBOX,
		id,
		format: type
	}
}
export const cleanProfileFormCheckbox = () => {
	return {
		type: c.CLEAN_PROFILE_FORM_CHECKBOX
	}
}

export const cleanClientProfileForm = () => {
	return {
		type: c.CLEAN_CLIENT_PROFILE_FORM
	}
}

export const clientProfileFormSentToFalse = () => {
	return {
		type: c.SENT_TO_FALSE_CLIENT_PROFILE_FORM
	}
}

export const clientProfileFormGetRelations = (clientNumber) => (dispatch) => {
	dispatch({
		type: "SHOW_LOADER",
	})

	return dispatch(fetchRelationClient(clientNumber)).then(function(response){
		dispatch({
			type: "HIDE_LOADER"
		})

		return response
	})
}

export const changeListDefaultError = (listType, listValue) => {
    return {
        type: c.TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM,
        listType: listType,
        listValue: listValue
    }
}

export const toggleModalClientProfileForm = (modalStatus) => {
	return {
		type: c.TOGGLE_MODAL_CLIENT_PROFILE_FORM,
		modalStatus: modalStatus
	}
}

export const fetchExistingClients = (data) => dispatch => (
    dispatch(apiCall('/data/clients', {data: trimObject(data)}))
        .then(response => {
            dispatch({type: c.FETCH_CLIENTS_CLIENT_PROFILE_FORM, response})
        })
)

export const fetchRelationClient = (data) => dispatch => (
	dispatch(apiCall('/data/clients', {data: trimObject(data)}))
		.then(response => {
			return { ... response }
		})
)

export const fetchExistingClient = (clientId, companyId) => dispatch => {
    return dispatch(apiCall('/data/client', {data: {clientId}}))
        .then(response => {
            if (typeof response == 'string') {
                response = response.replace(/\r\"/g,'"')
                response = JSON.parse(response)
            }

            if (companyId) {
                response.contracts = response.contracts.filter(i => i.contractMain.insuranceCompanyId == companyId)
            }
            dispatch({type: c.FETCH_CLIENT_CLIENT_PROFILE_FORM, clientId, response})
            dispatch({ type: c.SET_CLIENT_DATA, clientId, response })

            return response
        })
}

export const updateClientProfile = (data, clientId, companyId = null) => (dispatch) => {
	dispatch(apiCall('/api/updateClient/' + clientId, {data}))
        .then((data) => {
            if (data.result) {
                if (typeof data.result == 'string') {
                    data.result = data.result.replace(/\r?\n|\r/g, '')
                    data.result = data.result.replace(/\"W/g, 'W')
                    data.result = data.result.replace(/R\"/g, 'R')

                    data.result = JSON.parse(data.result)
                }

                let clientData = data.result

                if (Number(clientData.error) == 0) {
                    dispatch(toggleModalClientProfileForm(false))
                    dispatch(fetchClient(clientId, companyId))
                    dispatch(setOpened(clientId))
                    dispatch(setClientSubModule('profile'))
                    dispatch(setB2bCompanyOpened(clientId))
                    dispatch(setB2bCompanySubModule('profile'))
                    dispatch({type: c.UPDATE_CLIENT_PROFILE_RESULT, ok: true})
                }
                else {
                    dispatch({type: c.UPDATE_CLIENT_PROFILE_RESULT, ok: clientData.errorString})
                }
            }
        })
		.catch((err) => {
			dispatch({type: c.UPDATE_CLIENT_PROFILE_RESULT, err})}
		)
	return dispatch({type: c.FORM_SUBMITTED})
}

export const updateEasinsureClient = (profileData) => (dispatch) => (
	dispatch(apiCall('/data/easinsureClient', {
		method: 'POST',
		data: profileData,
	})).then((data) => {
		if (!data) {
			throw new Error('No data received (say: easinsureClient)')
		}

		const result = typeof data.result === 'string' ? JSON.parse(data.result) : null

		if (result && result.error === 0) {
			dispatch(fetchClientData()) // refresh the client data
		}
		return result // return the error (null or response result)
	}).catch((err) => {
		console.warn(err)
		return err.message
	})
)

export const createClientProfile = (data) => (dispatch) => {
    dispatch(apiCall('/api/createClient', {data}))
        .then((data) => {
            	if(data.result)
				{
                    if(typeof data.result == 'string')
                    {
                        data.result = data.result.replace(/\r?\n|\r/g,'')
                        data.result = data.result.replace(/\"W/g,'W')
                        data.result = data.result.replace(/R\"/g,'R')

                        data.result = JSON.parse(data.result)
                    }

					let clientData = data.result

                    if(Number(clientData.error) == 0)
                    {
                    	dispatch(toggleModalClientProfileForm(false))
                        dispatch(setOpened(clientData.clientId))
                        dispatch(setClientSubModule('profile'))
                        dispatch(setB2bCompanyOpened(clientData.clientId))
                        dispatch(setB2bCompanySubModule('profile'))
                        dispatch({type: c.UPDATE_CLIENT_PROFILE_RESULT, ok: true})
                    }
                    else
                    {
                        dispatch({type: c.UPDATE_CLIENT_PROFILE_RESULT, ok: clientData.errorString})
                    }
				}
		})
		.catch((err) => dispatch({type: c.UPDATE_CLIENT_PROFILE_RESULT, err}))
    return dispatch({type: c.FORM_SUBMITTED})
}

export const setClientCreateContractState = (createContractState) => (dispatch) => (
    dispatch({type: c.SET_CLIENT_CREATE_CONTRACT_STATE, createContractState})
)

/** END CLIENT PROFILE FORM ACTIONS **/

export const selectVisibleItems = (visibleItems) => ({
	type: c.SET_ALL_VISIBLE_CHECKED,
	visibleItems,
})

export const selectUnreadItems = (items) => ({
	type: c.SET_UNREAD_CHECKED,
	items,
})

export const setInboxFilter = (filter) => ({
	type: c.TICKETS_FILTERED,
	filter,
})

export const setOfficeSubModule = (subModuleName) => ({
	type: c.SET_OFFICE_SUB_MODULE,
	subModuleName,
})

export const setGeneral = (generalData) => ({
	type: c.SET_GENERAL,
	generalData,
})

const setOfficeData = (brokers, accountManagers) => {
	return {
		type: c.SET_OFFICE_DATA,
		brokers,
		accountManagers,
	}
}

export const fetchOfficeData = (resetSelectedBroker = false) => (dispatch, getState) => (
	dispatch(apiCall('/data/office'))
	.then((data) => {
		const brokers = {}
		for (const broker of data.officeInfo.brokers) {
			if (broker.main.website.slice(0, 4) !== 'http') {
				broker.main.website = `http://${broker.main.website}`
			}
			brokers[broker.brokerNumber] = broker
        }

        let officeDataPromise = dispatch(setOfficeData(brokers, data.accountManagers))

		//remove selected broker if this is from kantoor and is internal user
		if(resetSelectedBroker) {
			dispatch(setBrNr(''))
		}
		
		// preventing unnecessary change of the current brokerNumber and if is office then there should not be  preselected broker number
        if (!getState().app.brNr && !resetSelectedBroker) {
			dispatch(setBrNr(data.officeInfo.brokers[0].brokerNumber))
		}

		return data
	})
)

export const fetchClaims = (data) => async dispatch => {
	try {
		const response = await dispatch(transactionCall('/data/claims', { data: trimObject(data), noCache: true, noLoader: true }))
		await dispatch({ type: c.SET_CLAIMS_DATA, response })
		if (response.length === 1) {
			const { claimNumber } = response[0].main
			dispatch(setOpened(claimNumber))
		}
		return response

	} catch (error) {
		console.warn(error)
		return error
	}
}

export const navigateToConnexClaim = (module, claimNumber) => dispatch => {

	return dispatch(transactionCall('/data/claims', {data: trimObject({claimNumber}), noCache: true, noLoader: true}))
	.then(res => {
		dispatch({type: c.SET_APP_MODULE, module})
		dispatch({type: c.SET_CLAIMS_DATA, response: res})
		dispatch(setOpened(claimNumber))
		return
	})

}

export const setClientSubModule = (name, subModuleZoom, createContractState = null) => ({
	type: c.SET_CLIENT_SUB_MODULE,
	name,
    subModuleZoom,
	createContractState
})

export const setClientData = (data) => ({
	type: c.SET_CLIENTS_DATA, response: data
})

export const fetchClients = (data, justReturn = false) => dispatch => (
	dispatch(apiCall('/data/clients', {data: trimObject(data)}))
	.then(response => {

		dispatch(setClientData(response))

        if (response.length === 1 && !justReturn) {
            const {clientId} = response[0]
            dispatch(setOpened(clientId))
            // TODO this will skip all other filters, God mode for contractNumber
            let contractNumber = data.contractNumber && data.contractNumber.trim() || false
			let tarificationNumber = data.tarificationNumber && data.tarificationNumber.trim() || false
			let claimNumber = data.claimNumber && data.claimNumber.trim() || false
			let claimRefBroker = data.claimRefBroker && data.claimRefBroker.trim() || false
            if (contractNumber) {
                dispatch(setClientSubModule('contracts', {contractNumber}))
            } else if(tarificationNumber) {
                dispatch(setClientSubModule('tarification', {tarificationNumber}))
			} else if (claimNumber) {
				dispatch(setClientSubModule('claims', {claimNumber}))
			} else if (claimRefBroker) {
				dispatch(setClientSubModule('claims', {claimRefBroker}))
			}else {
                if (data && data.characteristicType && data.characteristicValue ) {
                    dispatch(setClientSubModule(
                        'contracts',
                        {characteristicType: data.characteristicType, characteristicValue: data.characteristicValue}
                    ))
                }
            }
        }

        return response
	})
)

export const fetchClientFinances = (clientId) => dispatch =>
	dispatch(apiCall('/data/getClientTransactions', {data: {clientId}}))
	.then(({transactions}) => dispatch({type: c.FETCHED_CLIENT_FINANCES, transactions, clientId}))

/**
 * This function will fetch the claims data for a client and put it in the redux store.
 * @param {*} clientId
 * @returns
 */
export const fetchClientClaims = (clientId) => async (dispatch) => {
    try {
		const response = await dispatch(transactionCall('/data/getClientClaims', {
		  data: { clientId },
		  noLoader: true,
		  noCache: true,
		}));
	
		dispatch({ type: c.FETCHED_CLIENT_CLAIMS, clientId, response });
	
		return response;
	  } catch (error) {
		console.error('Failed to fetch client claims:', error);
		throw error;
	  }
	}

export const fetchClientOneClaim = (clientId, claimId, userId) => async (dispatch) => {
	try {
		const fetchClaimsResponse = await dispatch(apiCall('/data/getClientClaims', {data: {clientId, userId}, noLoader: true, noCache: true}))

		if(fetchClaimsResponse && fetchClaimsResponse.claims) {
			return fetchClaimsResponse.claims.find(oneClaim => oneClaim.claimMain.claimId === claimId)
		}

	} catch (error) {
		return error
	}
}

/*
    // ------------------ for fetchClientClaims
    // original solution

    export const fetchClientClaims = (clientId) => dispatch =>
	dispatch(apiCall('/data/getClientClaims', {data: {clientId}}))
    .then(response =>
        dispatch({type: c.FETCHED_CLIENT_CLAIMS, clientId, response})
    )
*/


/**
 * This action will fetch a search result from server, looking for claims when client module is active
 * @param {*} data
 */
export const fetchClaimsExtraDetails = (data) => dispatch => (
    dispatch(transactionCall('/data/claims', {data: trimObject(data), noCache: true, noLoader: true}))
    .then(response => {
        return dispatch({type: c.CLIENT_LOAD_CLAIMS_EXTRA, response})
    })
)
export const fetchClientContract = (contractId) => dispatch =>
	dispatch(apiCall('/data/getClientContract', {data: {contractId}}))
	.then(response => dispatch({type: c.FETCHED_CLIENT_CONTRACT, contractId, response}))

export const fetchClient = (clientId, companyId = false, returnClient = false) => (dispatch, getState) =>
	dispatch(apiCall('/data/client', {data: {clientId}}))
	.then(response => {
        if(typeof response == 'string')
        {
            // Try to fix the error
            response = response.replace(/\r\"/g,'"')
            try {
                response = JSON.parse(response)
            } catch(e) {
                response = {}// error in the above string (in this case, yes)!
            }
        }

		if( companyId && response.contracts != undefined ) {
			response.contracts = response.contracts.filter(i => i.contractMain.insuranceCompanyId == companyId)
		}

		dispatch({type: c.SET_CLIENT_DATA, clientId, response})

        if (returnClient) {
            return response
        }

        return {
            client: getState().DSDocuments.client
        }
	})

export const setClientOptionsDict = ( clientOptionsDict ) => ({
	type: c.SET_CLIENT_OPTIONS_DICT,
	clientOptionsDict
})

export const fetchClientOptionsDict = () => (dispatch) => {
	return dispatch(apiCall('/dict/client/aml'))
	.then((dict) => {
        dispatch(setClientOptionsDict(dict))
		return dict
	})
}

export const createClientTarification = tarificationData => dispatch => {
	return dispatch(apiCall('data/createClientTarification', {data: tarificationData}))
		.then((res)=>{
			return res
		}).catch((err)=>{
			console.warn(err)
		})
}

export const fetchClientTarifications = clientId => dispatch => (
	dispatch(apiCall('data/getClientTarifications', {data: {clientId}}))
		.then(response => {
			try {
				const tarifications = response.tarifications
				return dispatch({type: c.FETCHED_CLIENT_TARIFICATIONS, clientId, tarifications})
			} catch (error) {
				console.warn(error);
			}
		})

)

export const fetchClientTarification = tarificationId => dispatch => {
	return dispatch(apiCall('data/getClientTarification', {data: {tarificationId}}))
		.then(response =>  dispatch({type: c.FETCHED_CLIENT_TARIFICATION_DATA, response}))
}

/**
 * Fetch the list of tarificatins for tarification mapping to contract
 * @param {*} clientId
 * @returns
 */
export const fetchUploadTarifications = clientId =>async dispatch => {
	try {
		const getUploadTarificationsResponse = await dispatch(apiCall('data/getUploadTarifications', {data: {clientId}}))
		if(getUploadTarificationsResponse) {
			return getUploadTarificationsResponse
		}
	} catch (error) {
		console.warn(error)
		return error
	}
}

/**
 * Fetch one tarification details for mapping
 * @param {*} tarificationId
 * @returns
 */
export const fetchOneTarificationDataForIndexMap = (tarificationId, indexTypes) =>async dispatch => {
	try {
		const getUploadTarificationsResponse = await dispatch(apiCall('data/getOneTarificationDataForIndexMap', {data: {tarificationId, indexTypes}}))
		if(getUploadTarificationsResponse) {
			return getUploadTarificationsResponse
		}
	} catch (error) {
		console.warn(error)
		return []
	}
}

export const filterClientFinances = (data) => ({
	type: c.FILTER_ITEMS,
	data: {
		startDate: data.startDate || '',
		endDate: data.endDate || '',
		contractNumber: data.contractNumber || '',
		invoiceNumber: data.invoiceNumber || '',
		paymentReference: data.paymentReference || '',
	},
})

export const getClientId = (contractId, claimId, tarificationId) => (dispatch) => {
    return dispatch(apiCall('/data/getClientId', {data: {contractId: contractId, claimId: claimId, tarificationId: tarificationId}}))
    .then(async response => {
        dispatch({
            type: c.GET_CLIENT_ID,
            clientId: (response && response.clientId) || false
        })

        return (response && response.clientId) || false
    })
    .catch((err) => {

        dispatch(setNotification(err, 'error'))

        dispatch({
            type: c.GET_CLIENT_ID,
            clientId: false
        })

        return false
    })
}

export const initContract = (brokerNumber) => dispatch => {
    return dispatch(apiCall('/data/initContract', {data: {brokerNumber}}))
}

export const createContract = (apiArguments) => dispatch => {
    return dispatch(apiCall('/data/createContract', {data: apiArguments}))
}


export const checkSMStoken = (token, onlyTesting = false, autoLogin = false) => (
	(dispatch) =>
		dispatch(apiCall("/auth/SMStoken", {data: {passcode: token, autoLogin: autoLogin}}))
		.then(response => {
			if (response.auth) {
				localStorage.smsToken = token
				//dispatch(getLoginRecordAndUpdate(response.userId, response.user))
				dispatch(saveUserLoginRecord(response.userId, response.user))

				dispatch(setApp(response))
				dispatch(setLang(response.lang))
				if (response.resetPassword) {
					dispatch(changeAuthState('passwordChange'))
				} else {
					dispatch(updateInbox())
					dispatch({type: c.LOG_IN})
				}
			} else if (!onlyTesting) {

				if (response.removeAutoLogin && response.removeAutoLogin  === true) {
					localStorage.removeItem('smsToken');
					return;
				}

				if (response.freeze && response.freeze === true) {
					if (response.time && response.time == '30s') {
						dispatch(hasErrors('freeze30s'));
					}

					if (response.time && response.time == '1m') {
						dispatch(hasErrors('freeze1m'))
					}

					if (response.time && response.time == '30m') {
						dispatch(hasErrors('freeze30m'))
					}
				} else if (response.blocked && response.blocked === true) {
					dispatch(changeAuthState(''))
					setTimeout(() => {
					dispatch(hasErrors('blocked'))
					},1000)
				} else {
					dispatch(hasErrors('sms'))
				}
			}
		})
)

const getLoginRecord =  () => (dispatch) => {
	return dispatch(apiCall('api/getUserLoginRecord'))
	.then( data => {
			return data
		})
}

const saveUserLoginRecord = (userId, user) => (dispatch) => {
	return dispatch(apiCall('api/saveUserLoginRecord', {data: {userId, userFullName: user}} ))
}

export const resendSMStoken = () => (
	(dispatch, getState) =>
		dispatch(apiCall("/auth/newToken", {method: 'POST'}))
		.then(() => {
			const {options} = getState().auth
			dispatch(changeAuthState('sms', {...options, smsSent: true, smsResent: true}))
		})
		.catch(() => dispatch(hasErrors('sms')))
)

export const retrievePassword = (email) => (
	(dispatch) =>
		dispatch(apiCall("/auth/retrievePassword", {data: {email}}))
		.then(response => {
			dispatch(changeAuthState('passwordReset', {...response}))
		})
)

export const passwordChangeRequired = (resetPassword) => ({
	type: c.APP_PASSWORD_CHANGED,
	resetPassword
})

export const changePassword = (oldPassword, newPassword) => (
	(dispatch) =>
		dispatch(apiCall('/api/chpwd', {data: {oldPassword, newPassword}}))
		.then((response) => {
			if( response.error === false || response.error === 'false') {
				dispatch(passwordChangeRequired(false))
				dispatch(changeAuthState(''))
				dispatch(updateInbox())
				dispatch({type: c.LOG_IN})
			} else {
				dispatch(hasErrors('passwordCannotBeOldone'));
			}
		})
		.catch(() => dispatch(hasErrors('oldPasswordWrong')))
)

// Check if our session is still valid
export const checkLoggedIn = () => (dispatch) =>
	dispatch(apiCall("/api/userInfo"))
	.then(
		(userInfo) => {
			dispatch(setApp(userInfo))
			dispatch(updateInbox())
			dispatch({type: c.LOG_IN})
		},
		() => false
	)

export const logIn = (username, password, lang = null) => (dispatch) => {
	const url = isClient ? '/auth/loginClient' : '/auth/login'

	const data =  {username, password}
	if(lang) {
		data.lang = lang
	}
	dispatch(apiCall(url, {data}))
	.then(
		response => {
			ga.event({
				category: 'User',
				action: (`${response.user} logged in`),
			})

			dispatch(setLang(response.lang))

			if (isClient) {
				dispatch(setClientApp(response))
				if (response.resetPassword) {
					dispatch(changeAuthState('passwordChange'))
				} else {
					dispatch({type: c.LOG_IN})
				}
			} else {
				dispatch({type: c.SET_PASSWORD, password})
				dispatch(changeAuthState('sms', {...response, smsResent: false}))
				if (localStorage.smsToken) {
					dispatch(checkSMStoken(localStorage.smsToken, false, true))
					.catch(() => false)
				}
			}
		},
		err => {
			if (err.status === 401 || (err && err.status === 403)) {
				dispatch(hasErrors('usernameAndPassword'))
			}
		}
	)
}

// UPLOAD
export const getUploadDict = () => (
	(dispatch, getState) => {
		if (!getState().uploads.dict) {
			return dispatch(apiCall('/dict/uploads'))
			.then(response => dispatch({type: c.SET_UPLOAD_DICT, dict: response}))
		}
	}
)

export const goToFileForm = (groupId, forceDescription = null) => (dispatch) => (
		dispatch({type: c.GO_TO_FILE_FORM, groupId, comment: forceDescription})
)

export const goBackToUploadType = () => (dispatch) => {
    dispatch({type: c.GO_BACK_TO_UPLOAD_TYPE})
    return Promise.resolve()
}

export const showUploadModal = (uploadType, uploadTypeId, uploadForceState = null, forceDescription = null, claimStatusAndQualification = null, forcedDocumentFromClaimWizard = '') => (
	async (dispatch) => {
		try {

			const url = `/api/uploadTypes/${uploadType}`
			let claimRequiredDocumentsRes
			const uploadTypesRes = await dispatch(apiCall(url))

			// on claim details page, when the claim status is 1 || 8 || 9  for groupType 1 we need to force mandatory documents for wizard and claim
			if (claimStatusAndQualification && (claimStatusAndQualification.claimStatus === '1' || claimStatusAndQualification.claimStatus === '8' || claimStatusAndQualification.claimStatus === '9')) {
				claimRequiredDocumentsRes = await dispatch(apiCall('/data/getClaimRequiredDocuments', { data: { ...claimStatusAndQualification } }))
				if (claimRequiredDocumentsRes) {
					uploadTypesRes[1] = claimRequiredDocumentsRes
				}
			}

			// if uploader is opened from a dsWizard that is opened from a claimWizard we need to force a document type for which the uploader is opened to groupType 1
			if (forcedDocumentFromClaimWizard) {
				const forcedDocumentObj = {}
				forcedDocumentObj[forcedDocumentFromClaimWizard] = { max: 0, min: 0 }
				uploadTypesRes[1] = forcedDocumentObj
			}

			dispatch({ type: c.SHOW_UPLOAD_MODAL, uploadType, uploadInfo: uploadTypesRes, uploadTypeId })

			const keys = Object.keys(uploadTypesRes)

			switch (uploadForceState) {
				case UPLOADER_STATE_NEW_POLICY: {
					let uploadTypeIndex = keys.indexOf(UPLOADER_STATE_NEW_POLICY_ID)

					if ((uploadTypeIndex !== -1)) {
						dispatch(goToFileForm(keys[uploadTypeIndex], forceDescription))
					} else {
						if (keys.length === 1) {
							dispatch(goToFileForm(keys[0]))
						}
					}

					break
				}

				case UPLOADER_STATE_POLICY_FILE: {
					let uploadTypeIndex = keys.indexOf(UPLOADER_STATE_POLICY_FILE_ID)

					if ((uploadTypeIndex !== -1)) {
						dispatch(goToFileForm(keys[uploadTypeIndex], forceDescription))
					} else {
						if (keys.length === 1) {
							dispatch(goToFileForm(keys[0]))
						}
					}

					break
				}

				default: {
					if (keys.length === 1) {
						dispatch(goToFileForm(keys[0]))
					}
				}

			}

		} catch (error) {
			console.warn(error);
		}
	}
)

export const hideUploadModal = () => ({
	type: c.HIDE_UPLOAD_MODAL,
})

export const changeFileDate = (date, file, filetype) => ({
	type: c.CHANGE_FILE_DATE,
	date, file, filetype,
})

export const removeFile = (file, fileType) => ({
	type: c.REMOVE_FILE,
	file, fileType
})

export const unAllocateFile = (file, fileTypeId) => ({
	type: c.UN_ALLOCATE_FILE,
	file, fileType: fileTypeId
})

export const allocateFiles = (typeId, file) => ({
	type: c.ALLOCATE_FILE,
	typeId, file,
})

export const addFiles = (files) => ({
	type: c.ADD_FILES,
	files
})

/**
 *
 * @param {*} files
 * @param {Boolean} disableUploadToOracle  V8.0 - can be uploaded file only to the will-broker server temporary, whn it is true
 * @returns
 */
export const startUpload = (files, disableUploadToOracle = null) => (
	async (dispatch, getState) => {
		const groupId = getState().uploads.groupId
		const uploadId = getState().uploads.uploadId
		const uploadInfo = getState().uploads.uploadInfo.filter(info => info.id === groupId)[0]
		let fData

        let uploadPromises = []

        dispatch({type: c.UPLOAD_CLEAR_ERROR})

        await getPromiseForTranslations()

		for (const type of uploadInfo.fileTypes) {
			if (type.files) {
				for (const file of type.files) {
					//if file origin is tarification we will use the new index type migration
					if (file.name) {
						let oneFilePromise = new Promise((resolveFileUpload, rejectFileUpload) => {
							// I am not sure when and why is calling start upload when the files are already uploaded, or are under progress.
							// So here I will not resolve my promise, because for that is only one way, finishing an upload, else that must be rejected.
							if (file.done || (!file.error && file.progress > 0)) {
								return rejectFileUpload({ filetype: type.id, fileId: file.fileId, error: "Unwanted call for restarting an already started upload." })
							}
							// if (file.origin && file.origin === 'ORIGIN_ORACLE_TARIFICATION') {

							// } else {

								fData = new FormData()
								fData.append('disableUploadToOracle', disableUploadToOracle)
								fData.append('uploadId', uploadId)
								fData.append('type', type.id)
								fData.append('comment', file.name)
								fData.append('originalFileName', file.name)
								fData.append('date', serverDateFormat(file.lastModified))

								if (file.origin && file.origin === 'DS_ORIGIN_ORACLE' ) {
									fData.append('origin', file.origin)
									fData.append('oracleDocumentId', file.fileId )
									fData.append('documentTypeIdx', file.documentTypeIdx)
									fData.append('oracleDocumentType', file.typeDocument)
								}

								fData.append('file', files[file.fileId])
								const request = new XMLHttpRequest()

								request.onreadystatechange = () => {
									if (request.readyState === 4) {
										// EXIT POINT status not 200
										if (request.status !== 200) {
											dispatch({ type: c.UPLOAD_ERROR, filetype: type.id, fileId: file.fileId })

											// rejecting promise of this individual upload
											return rejectFileUpload({ filetype: type.id, fileId: file.fileId, error: "request.status !== 200" })
										}

										// status is 200
										try {
											const resp = JSON.parse(request.response)
											let errorFound = nesProp.get(resp, "success.error") || nesProp.get(resp, "error")

											if (errorFound) {
												let statusText
												if (nesProp.get(resp, "success.error") === "conversionFail") {
													statusText = translate("unknownErrorOccurred")
												} else {
													statusText = nesProp.get(resp, "success.error") ||
														translate("unknownErrorOccurred") + ": " + nesProp.get(resp, "message") ||
														translate("unknownErrorOccurred") + ": " + JSON.stringify(request.responseText)
												}

												dispatch({ type: c.UPLOAD_ERROR, filetype: type.id, fileId: file.fileId, error: statusText })

												// rejecting promise of this individual upload
												return rejectFileUpload({ filetype: type.id, fileId: file.fileId, error: statusText })
											} else {
												dispatch({ type: c.UPLOAD_DONE, filetype: type.id, fileId: file.fileId, response: nesProp.get(resp, "success") })

												// resolving promise of this individual upload
												return resolveFileUpload({
													filetype: type.id,
													fileId: file.fileId,
													response: nesProp.get(resp, "success")
												})
											}
										} catch (err) {
											let statusText = nesProp.get(request, "response.message") || JSON.stringify(request.responseText)
											const error = {
												status: 'error',
												data: translate("unknownErrorOccurred") + ": " + statusText,
											}
											dispatch({ type: c.UPLOAD_ERROR, filetype: type.id, fileId: file.fileId, error })

											// rejecting promise of this individual upload
											return rejectFileUpload({ filetype: type.id, fileId: file.fileId, error })
										}
									}
								}

								request.upload.addEventListener('progress', (e) => {
									const progress = e.loaded / e.total

									dispatch({ type: c.UPLOAD_PROGRESS, filetype: type.id, fileId: file.fileId, progress })
								}, false)

								request.open('POST', '/api/upload', true)
								request.setRequestHeader('x-csrf-token', translate('csrfclienttoken'))
								request.send(fData)
							// }
						})

						// collect upload promises
						uploadPromises.push(oneFilePromise)
					}
				}
			}
		}

        // fire all upload together, not matter if some of the failed from point of view this branch of process.
        // error handling is made by dispatching values in store, in a lower level, individually for each file.
        let allUploadResult = Promise.allSettled(uploadPromises)

        // when all upload is done, this then actually made for debugging only
        .then((results)=>{
            return results
        })

        // handle errors
        .catch((err) => {
            console.warn("Upload files ", err)
            return err
        })

		dispatch({type: c.START_UPLOAD})

        return allUploadResult
	}
)

/**
 *
 * @param {*} comment
 * @param {*} files
 */
export const uploadFiles = (comment, files, disableUploadToOracle = false) => async (dispatch, getState) => {
    // if uploadId already got from oracle should start the upload and return
    if (getState().uploads.uploadId) {
        return dispatch(startUpload(files, disableUploadToOracle))
    }// else create upload on Oracle

    //determine on witch module must upload the files based on uploadTypeId (selected by dropdown before upload)
    let data
	switch (getState().uploads.uploadType) {
		case 'client':
			data = {type: getState().uploads.groupId, clientId: getState().uploads.uploadTypeId}
			break
		case 'contract':
			data = {type: getState().uploads.groupId, contractId: getState().uploads.uploadTypeId}
			break
		case 'claim':
			data = {type: getState().uploads.groupId, claimId: getState().uploads.uploadTypeId}
			break
		case 'tarification':
			data = {type: getState().uploads.groupId, tarificationId: getState().uploads.uploadTypeId}
		default:
			break
	}

    // if there is a comment filled in the popup textarea, wil be attached to the upload for oracle
	if (comment) {
		data.comment = comment
	}

    // when the files are stored only on willemot-broker server, they are not sent to ORACLE. The result filenames
    // are returned
	if (disableUploadToOracle) {
		data.disableUploadToOracle = disableUploadToOracle
	}

    // call the createUpload API to get an uploadId from Oracle to continue the upload by a second step.
	let response = await dispatch(apiCall('/api/createUpload', {data}))

	try {
        // in case when dont have provided uploadId by oracle
        if (!response.uploadId){
            const groupId = getState().uploads.groupId
            const uploadInfo = getState().uploads.uploadInfo.find(info => info.id === groupId)
            let errors = []

            for (const type of uploadInfo.fileTypes) {
                if (type.files) {
                    for (const file of type.files) {
                        if (file.name) {
                            const error = translate("unknownErrorOccurred");
                            errors.push({type: c.UPLOAD_ERROR, filetype: type.id, fileId: file.fileId, error:error})
                            dispatch({type: c.UPLOAD_ERROR, filetype: type.id, fileId: file.fileId, error:error})
                        }
                    }
                }
            }

            // EXIT POINT
            throw new Error(errors)
        }

        dispatch({type: c.SET_UPLOAD_ID, uploadId: response.uploadId})
        // when the uploadID arrived start uploading the file using a second API call
        return dispatch(startUpload(files, disableUploadToOracle))
    } catch(err) {
        console.warn('create upload error ', err)
        return err
    }
}

export const getUploads = (type, id, force) => (
	(dispatch, getState) => {
		let data
		const {files} = getState()
		const actFiles = files[type][id]

		switch (type) {
			case 'client':
				data = {clientId: id}
				break
			case 'contract':
				data = {contractId: id}
				break
			case 'claim':
				data = {claimId: id}
				break
			case 'tarification':
				data = {tarificationId: id}
				break
			default:
				break
		}

		if (!actFiles || Date.now() - actFiles.ts > STALE_TIME || force) {
			return dispatch(apiCall('/api/getUploads', {data}))
			.then(response => {
				dispatch({type: c.GET_UPLOADS, files: response, uploadType: type, typeId: id})
			})
		}
		return Promise.resolve()
	}
)

export const updateCommentBemDoc = ({
	documentId,
	bemComment,
	typeId,
	uploadId,
	uploadType,
}) => (dispatch, getState) => {
	const isFile = Boolean(documentId) // chech if is document part of file or document

	dispatch(apiCall('/data/updateCommentBemDoc', {
		method: 'POST',
		data: {
			documentId: isFile ? documentId : uploadId,
			bemComment: bemComment.commentValue,
		},
	})).then((response) => {
		if (!response) {
			throw new Error('No data received (say: updateCommentBemDoc)')
		}

		if (response && response[0].error === 0) {
			const actionData = {
				typeId,
				uploadId,
				uploadType,
				documentId,
				bemComment,
			}

			switch (uploadType) {
				case 'client':
					dispatch({
						type: isFile ? c.CLIENT_FILE_DOC_UPDATE_BEM_COMMENT : c.CLIENT_DOC_UPDATE_BEM_COMMENT,
						...actionData,
					})
					break
				case 'claim': {
					const { app } = getState()
					dispatch({
						type: isFile ? c.CLAIM_FILE_DOC_UPDATE_BEM_COMMENT : c.CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT,
						...actionData,
						clientNumber: app.opened,
					})
					break
				}
				case 'contract': {
					dispatch({
						type: isFile ? c.CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT : c.CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT,
						...actionData,
					})
					break
				}
				case 'tarification':
					dispatch({
						type: c.TARIFICATION_DOC_UPDATE_BEM_COMMENT,
						...actionData,
					})
					break
				default:
					return response
			}
			dispatch(setNotification(translate('Comment_updated'), 'success'))
		}
		if (response && response[0].error === 1) {
			dispatch(setNotification(translate('Update_failed,_document_id_not_found'), 'error'))
		}
		return response
	}).catch((err) => {
		console.warn(err)
		dispatch(setNotification(translate('Comment_update_failed'), 'error'))
	})
}

export const cancelUpload = () => (dispatch, getState) => {
	const {uploads} = getState()

	if (uploads.uploadType && uploads.uploadTypeId) {
		dispatch(getUploads(uploads.uploadType, uploads.uploadTypeId, true))
	}

	dispatch({type: c.CANCEL_UPLOAD})
}

export const updateCommentOnFileUpload = (comment) => (dispatch) => {
	dispatch({type: c.UPDATE_UPLOAD_COMMENT, comment: comment})
}

export const initAdditionalUpload = (uploadType, uploadTypeId, item) => (dispatch, getState) => {
	const dict = getState().uploads.dict
	// TODO change type title to id when oracle sends it
	const groupId = findKey(dict.uploadType, i => (i.nl === item.type || i.fr === item.type))
	const url = `/api/uploadTypes/${uploadType}`

	dispatch(apiCall(url))
	.then(
		(response) => {
			dispatch({type: c.SHOW_UPLOAD_MODAL, uploadType, uploadInfo: response, uploadTypeId})
			dispatch({type: c.GO_TO_FILE_FORM, groupId, uploadId: item.uploadId, comment: item.comment})

			if (item.documents) {
				for (const document of item.documents) {
					const documentTypeId = findKey(dict[uploadType], i => (i.nl === document.documentType || i.fr === document.documentType))
					dispatch(addFiles(documentTypeId, [document]))
				}
			}
		}
	)
}
export const getTranslations = () => dispatch => (
	dispatch(apiCall('/translations'))
	.then(
		response => dispatch({type: c.GOT_TRANSLATIONS, dict: response}),
		// We update so that translationIds become visible, see i18n
		() => dispatch({type: c.GOT_TRANSLATIONS, dict: {FAIL: true}})
	)
)

// Registration
export const sendForm = (data) => (dispatch) => {
	dispatch(apiCall('/register', {data}))
	.then(
		() => dispatch({type: c.REG_RESULT, ok: true}),
		(err) => dispatch({type: c.REG_RESULT, err})
	)
	return dispatch({type: c.FORM_SUBMITTED})
}
export const backToForm = () => ({type: c.RESET_REG})

export function fetchClientData() {
	return (dispatch) => {
		dispatch(apiCall('/data/client'))
		.then(response => {
			return dispatch({type: c.SET_CLIENT, response})
		})
	}
}

export const setContractFilter = (filter) => ({
	type: c.SET_FILTER,
	filter,
})

export const fetchContractData = (id) => (dispatch, getState) => {
	const contracts = getState().client.contracts
	let contract

	for (const k of Object.keys(contracts)) {
		for (const c of contracts[k]) {
			if (c.contractId === id) {
				contract = c
			}
		}
	}

	if (contract && !contract.contractDetails) {
		return dispatch(apiCall('/data/getClientContract', {data: {contractId: id}}))
		.then(response => dispatch({type: c.SET_CONTRACT_DETAILS, response, id}))
	}
}

/**
 * This function fetch the client claims data to store and return with a promise.
  * @returns promise and set result in the redux-store
 */
export const fetchClaimsData = () => (dispatch, getState) => {
    const claims = getState().client.claims

    if (claims.length === 0) {
        return dispatch(apiCall('/data/getClientClaims'))
		.then(response => dispatch({type: c.SET_CLIENT_CLAIMS, response}))
    }
}

/**
 *  This function will fetch the claim details by claimId
 */
export const getClaimDetail = (claimId) => (dispatch, getState) => {
	const claims = getState().client.claims

	if (claims.length === 0) {
		return dispatch(apiCall('/data/getClaimDetail', {
            data: {claimId}
        }))
		.then(response => dispatch({type: c.SET_CLAIM_DETAIL, response}))
	}
}

export const getWebapps = () => (dispatch) => (
	dispatch(apiCall('/api/getWebapps'))
	.then(response => dispatch({type: c.GOT_WEBAPPS, response}))
)

export const fetchSubscribersList = (id) => dispatch => (
	dispatch(apiCall(`/api/getSubscribers/${id}`))
	.then(response => {
		const subscribers = response.subscriberIds || response
		const formattedSub = subscribers.map(sub => ({officeId: sub.officeId, broker: sub.brokerName, firstName: sub.name && sub.name.first, lastName: sub.name && sub.name.last, street: cs(sub.street, sub.houseNum, sub.houseNumExt), zip: cs(sub.zip, sub.city), birthday: formatDate(sub.birthday), email: sub.email}))
		const fields = ['officeId', 'broker', 'firstName', 'lastName', 'street', 'zip', 'birthday', 'email']
		const fieldNames = ['OfficeNr', 'Broker', 'Naam', 'Vrnaam', 'Adres', 'Gemeente', 'GeboorteD', 'Email']

		json2csv({data: formattedSub, fields, fieldNames, del: ';'}, (err, csv) => {
			if (err) {
				dispatch(setNotification(err, 'error'))
			} else {
				const blob = new Blob([csv], {type: "text/csv;charset=utf-8"})
				FileSaver.saveAs(blob, `event-subscribers.csv`)
			}
		})
	})
)

const fetchAdminDocsPs = {}
export const fetchAdminDocs = (brNr) => (dispatch) => {
	let p = fetchAdminDocsPs[brNr]
	if (!p) {
		const data = {brokerNumber: brNr}
		p = fetchAdminDocsPs[brNr] = dispatch(apiCall('/api/getAdminDoc', {data}))
		.then(data => dispatch(gotAdminDocs(data, brNr)))

		const clear = () => {fetchAdminDocsPs[brNr] = null}
		p.then(clear, clear)
	}
	return p
}

export function gotAdminDocs(data, brNr) {
	return {
		type: c.FETCHED_ADMIN_DOCS,
		data, brNr,
	}
}

// b2bCompany module related actions
export const setB2BInsuranceCompany = (b2bInsuranceCompany) => ({
	type: c.SET_B2B_INSURANCE_COMPANY,
	b2bInsuranceCompany
})

export const setB2bCompanySubModule = (name, subModuleZoom) => ({
	type: c.SET_B2BCOMPANY_SUB_MODULE,
	name,
	subModuleZoom,
})

export const setB2bCompanyBrNr = (brNr) => ({
	type: c.B2BCOMPANY_BRNR_USED,
	brNr,
})

export const setB2bCompanyOpened = (itemId) => ({
	type: c.B2BCOMPANY_ITEM_ZOOMED,
	itemId,
})

export const setB2bCompanySearchByContractNumber = (isByContractNumber) => ({
	type: c.B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER,
	isByContractNumber
})

export const fetchB2bCompanyClients = (data) => dispatch => (
	dispatch(apiCall('/data/clients', {data: trimObject(data)}))
	.then(response => {
		dispatch({type: c.SET_B2BCOMPANY_CLIENTS_DATA, response})
		if (response.length === 1) {
			const {clientId} = response[0]
			dispatch(setB2bCompanyOpened(clientId))
			if (data.contractNumber) {
				const {contractNumber} = data
				dispatch(setB2bCompanySearchByContractNumber(true))
				dispatch(setB2bCompanySubModule('profile', {contractNumber}))
			} else {
				dispatch(setB2bCompanySearchByContractNumber(false))
			}
		}
	})
)

export const setB2bCompanyPolicyActions = (policyActions, policySubActions) => ({
	type: c.B2BCOMPANY_GET_ACTIONS,
	policyActions,
	policySubActions
})

export const setB2bCompanyCompanyDetails = ( b2bCompanyCompany ) => ({
	type: c.B2BCOMPANY_SET_COMPANY,
	b2bCompanyCompany
})

export const b2bCompanySwitchSubActions = (policySubActions) => ({
	type: c.B2BCOMPANY_SWITCH_ACTION,
	policySubActions
})

export const fetchB2bCompanyPolicyActionsDict = () => (dispatch) => {
	return dispatch(apiCall('/dict/b2bCompany'))
	.then((dict) => {
		return dispatch(setB2bCompanyPolicyActionsDict(dict))
	})
}

export const setB2bCompanyPolicyActionsDict = (b2bCompanyActionsDict) => ({
	type: c.B2BCOMPANY_SET_ACTIONS_DICT,
	b2bCompanyActionsDict
})

export const fetchB2bCompanyPolicyActions = (clientId, b2bInsuranceCompany) => (dispatch) => {
	return dispatch(apiCall('/api/b2bCompany'))
	.then((data) => {
		const policyAction = {}
		const policySubActions = {}
		let b2bCompanyData = {}
		let b2bCompanyCompany = {}
		for (const oneData of data || []) {
			if (underscore.isEqual(oneData.company.companyId, b2bInsuranceCompany)) {
				b2bCompanyData = oneData.actionTypes
				b2bCompanyCompany = oneData.company
				break
			}
		}
		if ( !lodash.isEmpty(b2bCompanyData) ) {
			if (b2bCompanyData && b2bCompanyData) {
				for (const cAction of b2bCompanyData || []) {
					policyAction[cAction.action] = cAction
				}
			}
		}
		const firstCategoryKey = policyAction && Object.keys(policyAction)[0] || false
		const firstCategory = firstCategoryKey && policyAction[firstCategoryKey].actionCategories || false
		for (const cSubAction of firstCategory || []) {
			policySubActions[cSubAction.category] = cSubAction
		}

		dispatch(setB2bCompanyPolicyActions(policyAction, policySubActions))
		dispatch(setB2bCompanyCompanyDetails(b2bCompanyCompany))
		dispatch(getB2bCompanyB2BTransactions({companyId: b2bCompanyCompany.companyId,clientId: clientId}))
		return {policyAction, policySubActions, b2bCompanyCompany}
	})
}

export const gotB2bCompanyPolicy = (policies) => ({type: c.B2BCOMPANY_FETCHED_POLICIES, policies})

export const setB2bCompanySelectedPolicy = (selectedPolicy) => ({type: c.SET_B2BCOMPANY_SELECTED_POLICY, selectedPolicy})

export const B2bCompanyStartB2BAction = (args) => (dispatch) => {
	const data = {
		clientId: args.clientId,
		brokerNumber: args.brokerNumber,
		companyId: args.companyId,
		action: args.action,
		category: args.category,
		contractNumber: args.contractNumber,
		contractId: args.contractId,
		b2bScenario: args.b2bScenario,
		actionCode: args.actionCode,
		domain: args.domain,
		transactionId: args.transactionId || "",
		recupCode: args.recupCode || "",
    }

	/*if (err) {
		return dispatch(setNotification(err, 'error'))
	}*/

	return dispatch(apiCall('/api/startB2BAction', {data: trimObject(data)}))
	.then((data) => {
		dispatch(setB2bCompanyB2BTransactionDetails(data))
		dispatch(getB2bCompanyB2BTransactions({companyId: args.companyId, clientId: args.clientId}))
		return data
	})
	.catch(
		err => dispatch(setNotification('Could not effect this action on policy!', 'error'))
	)
}
/**
 * This action for start the vivium recuperation. This is a separated function for vivium at the moment (02.11.2017)
 * @param {*} args
 */
export const B2bCompanyB2bActionRecup = (args) => (dispatch) => {
	const data = {
        transactionId: args.transactionId || ""
    }

    return dispatch(apiCall('/api/B2BActionRecup', {data: trimObject(data)}))
	.then((data) => {
        // We dont have to do nothing with this. This contains only a status message.
		return data
	})
	.catch(
		err => dispatch(setNotification('Could not effect the recuperation!', 'error'))
	)
}

export const setB2bCompanyB2BTransactionDetails = (transactionDetails) => ({
	type: c.B2BCOMPANY_SET_TRANSACTION_DETAILS,
	transactionDetails
})

export const getB2bCompanyB2BTransactions = (args) => (dispatch) => {
	const data = {
		clientId: args.clientId,
		companyId: args.companyId
	}

	return dispatch(apiCall('/api/getB2BTransactions', {data: trimObject(data)}))
	.then((data) => {
            // convert the transaction date format for every transaction
            const transactions = data && data.transactions && data.transactions.map(
                (currentValue, index) => {
                    return {...currentValue,
                        ...{transactionDate: moment(currentValue.transactionDate, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm")}
                    }
                }
            ) || []
			dispatch(setB2bCompanyB2BTransactions(transactions))
		}
	)
}

export const setB2bCompanyB2BTransactions = (B2BTransactions) => ({
	type: c.B2BCOMPANY_SET_TRANSACTIONS,
	B2BTransactions
})

const formatB2bCompanyPolicy = (policy) => {
	Object.keys(policy).forEach((index) => {
		if (policy[index] === null) {
			(policy)[index] = ""
		}
	})
	return ({
		...policy,
		original: JSON.stringify(policy),
		address: policy.street && policy.houseNum && policy.zip && policy.city ? `${policy.street} ${policy.houseNum}, ${policy.zip} ${policy.city}` : '',
		birthday: policy.birthday ? formatDate(policy.birthday, 'eu') : '',
		phone: policy.phone,
		email: policy.email,
	})
}

export const loadB2bCompanyPolicy = () => dispatch => (
	dispatch(apiCall('/api/getB2bCompanyPolicies'))
	.then((data) => dispatch(gotB2bCompanyPolicy(data.map(formatB2bCompanyPolicy))))
)

export const setB2bCompanyPolicy = (data) => dispatch => (
	dispatch(apiCall(`/api/b2bCompany/${data._id || ''}`, {data}))
	//.then(() => dispatch(loadB2bCompanyPolicies()))
	.catch(() => dispatch(setNotification('Could not save the policy!', 'error')))
)

export const showB2bCompanyPolicyModal = id => ({
	type: c.SHOW_B2BCOMPANY_POLICY_MODAL,
	id,
})

export const hideB2bCompanyPolicyModal = () => ({
	type: c.HIDE_B2BCOMPANY_POLICY_MODAL,
})

export const setB2bCompanyClientAction = (currentClientAction) => ({
	type: c.B2BCOMPANY_CLIENT_ACTION_USED,
	currentClientAction,
})

export const setB2bCompanyClientSubAction = (currentClientSubAction) => ({
	type: c.B2BCOMPANY_CLIENT_SUB_ACTION_USED,
	currentClientSubAction,
})

const setB2bCompanyBrokersData = (brokers, accountManagers) => ({
		type: c.SET_B2BCOMPANY_BROKERS_DATA,
		brokers,
		accountManagers
})

export const fetchB2bCompanyBrokers = () => (dispatch) => (
	dispatch(apiCall('/data/office'))
	.then((data) => {
		const brokers = {}
		for (const broker of data.officeInfo.brokers) {
			if (broker.main.website.slice(0, 4) !== 'http') {
				broker.main.website = `http://${broker.main.website}`
			}
			brokers[broker.brokerNumber] = broker
		}
		dispatch(setB2bCompanyBrokersData(brokers, data.accountManagers))
		dispatch(setB2bCompanyBrNr(data.officeInfo.brokers[0].brokerNumber))
	})
)

/** TASK MODULE ACTIONS
***********************************************************************************************************************/
/**
 * Modals related actions
 * Here you can find all the list getters
 */
export const taskModuleListGet = () => (dispatch) => {
	dispatch(apiCall('/api/getTasks'))
	.then((data) => {
		dispatch(taskModuleListSet(data))
	})
}
const taskModuleListSet = (tasks) => ({
	type: c.TASK_MODULE_LIST_SET,
	tasks
})

export const taskModuleListGetDefaultColors = () => (dispatch) => {
	dispatch(apiCall('/api/getTaskDefaultColors'))
	.then((data) => {
		dispatch(taskModuleListDefaultColorsSet(data))
	})
}
const taskModuleListDefaultColorsSet = (taskColors) => ({
	type: c.TASK_MODULE_LIST_DEFAULT_COLORS_SET,
	taskColors
})

export const taskModuleListGetUserColors = () => (dispatch) => {
	dispatch(apiCall('/api/getTaskUserColors'))
	.then((data) => {
		dispatch(taskModuleListUserColorsSet(data))
		dispatch(taskModuleFilterClean())
	})
}
const taskModuleListUserColorsSet = (taskColors) => ({
	type: c.TASK_MODULE_LIST_USER_COLORS_SET,
	taskColors
})

/**
 * Modals related actions
 *
 * Here you can find all actions that are related to modals
 */
export const taskModuleModalToggle = (modalType) => ({
	type: c.TASK_MODULE_MODAL_TOGGLE,
	modalType
})
export const taskModuleModalNotificationSet = (notificationType, itemId = null) => (dispatch) => {
	dispatch({type: c.TASK_MODULE_MODAL_NOTIFICATION_SET, notificationData: {notificationType, itemId}})
	dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_NOTIFICATION))
}
export const taskModuleModalNotificationReset = () => ({
	type: c.TASK_MODULE_MODAL_NOTIFICATION_RESET
})

/**
 * Forms related actions
 *
 * Here you can find all the global form actions
 */
export const taskModuleFormCleanAction = (formType) => (dispatch) => {
	dispatch(taskModuleFormClean(formType))
}
export const taskModuleFormEditSetAction = (formType, entityId) => (dispatch) => {
	dispatch(taskModuleFormEditSet(formType, entityId))
}
const taskModuleFormError = (error, formType) => ({
	type: c.TASK_MODULE_FORM_ERROR,
	response: {error: error, formType: formType}
})
const taskModuleFormClean = (formType) => ({
	type: c.TASK_MODULE_FORM_CLEAN,
	formType
})
const taskModuleFormCleanMessage = ( formType ) => ({
	type: c.TASK_MODULE_FORM_CLEAN_MESSAGE,
	formType
})
const taskModuleFormEditSet = (formType, entityId) => ({
	type: c.TASK_MODULE_FORM_EDIT_SET,
	response: {entityId: entityId, formType: formType}
})


/**
 * Task form related actions
 *
 * Here you can find all actions that are related to task form
 */
export const taskModuleFormCreateTask = (taskData) => (dispatch) => {
	dispatch(taskModuleFormCleanMessage('manageTask'))

	dispatch(apiCall('/api/createTask', { data: taskData }))
	.then((data) => {
		dispatch(taskModuleListGet())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_MANAGE_TASK))
		dispatch(taskModuleFormClean('taskForm'))
	},(err) => dispatch(taskModuleFormError(err, 'manageTask')))
}

export const taskModuleFormUpdateTask = (taskData) => (dispatch) => {
	dispatch(taskModuleFormCleanMessage('manageTask'))

	dispatch(apiCall('/api/updateTask', { data: taskData }))
	.then((data) => {
		dispatch(taskModuleListGet())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_MANAGE_TASK))
		dispatch(taskModuleFormClean('manageTask'))
	},(err) => dispatch({type: c.TASK_MODULE_FORM_TASK_ERROR, err}))
}
export const taskModuleTaskDelete = (items) => (dispatch) => {
	let itemIds = items.filter(i => i.checked === true).map(i => i)
	itemIds = itemIds.filter(item => !item.hidden).map(i => i.id)

	dispatch(apiCall('/api/deleteTask', { data: {taskIds: itemIds}}))
	.then((data) => {
		dispatch(taskModuleListGet())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_NOTIFICATION))
		dispatch(taskModuleModalNotificationReset())
	})
}

/**
 * TaskColorCode form related actions
 *
 * Here you can find all actions that are related to task form
 */
export const taskModuleFormCreateTaskColor = (taskColorData) => (dispatch) => {
	dispatch(taskModuleFormCleanMessage('manageColorPicker'))

	dispatch(apiCall('/api/createTaskColor', { data: taskColorData }))
	.then((data) => {
		dispatch(taskModuleListGetUserColors())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER))
		dispatch(taskModuleFormClean('manageColorPicker'))
	},(err) => dispatch(taskModuleFormError(err, 'manageColorPicker')))
}
export const taskModuleFormUpdateTaskColor = (taskColorData) => (dispatch) => {
	dispatch(taskModuleFormCleanMessage('manageColorPicker'))

	dispatch(apiCall('/api/updateTaskColor', { data: taskColorData }))
	.then((data) => {
		dispatch(taskModuleListGetUserColors())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER))
		dispatch(taskModuleFormClean('manageColorPicker'))
		dispatch(taskModuleListGet())
	},(err) => dispatch(taskModuleFormError(err, 'manageColorPicker')))
}
export const taskModuleTaskColorDelete = (taskColorId) => (dispatch) => {
	dispatch(apiCall('/api/deleteTaskColor', { data: {id: taskColorId}}))
	.then((data) => {
		dispatch(taskModuleListGetUserColors())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_NOTIFICATION))
		dispatch(taskModuleModalNotificationReset())
		dispatch(taskModuleListGet())
	})
}
export const taskModuleTaskColorReset = () => (dispatch) => {
	dispatch(apiCall('/api/resetTaskColor', { data: {}}))
	.then((data) => {
		dispatch(taskModuleListGetUserColors())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_NOTIFICATION))
		dispatch(taskModuleModalNotificationReset())
		dispatch(taskModuleListGet())
	})
}

/**
 * Task filter actions
 *
 * Here you can find all filter actions for task module
 */
export const taskModuleFilter = (filterStatusValue, filterColorValue) => ({
	type: c.TASK_MODULE_FILTER,
	filterOptions: {filterStatusValue, filterColorValue}
})
export const taskModuleFilterClean = () => ({
	type: c.TASK_MODULE_FILTER_CLEAN,
})

/**
 * Task items checkbox actions
 *
 * Here you can find all actions that help the table list to check items
 */
export const taskModuleItemCheck = (itemId) => ({
	type: c.TASK_MODULE_ITEM_SET_CHECK,
	itemId
})
export const taskModuleItemCheckAllVisible = (visibleItems) => ({
	type: c.TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE,
	visibleItems,
})


/** INBOX AND TASK LIST RELATED ACTIONS - THIS FUNCTIONS ARE RELATED TO TICKET AND TASK MODELS
***********************************************************************************************************************/
export const fetchStaffList = () => dispatch => (
	dispatch(apiCall('/api/getStaffList', {data: {}}))
	.then(response => {
		dispatch({type: c.INBOX_ARCHIVE_SET_STAFF_LIST, response})
	})
)
export const resetStaffList = () => dispatch => (
	dispatch({type: c.INBOX_ARCHIVE_RESET_STAFF_LIST})
)

export const archiveToggleModal = () => dispatch => (
	dispatch({type: c.INBOX_ARCHIVE_MODAL_TOGGLE})
)

export const archiveRelational = (items,type) => (dispatch) => {
	const itemsData = {
		noRelation: [],
		relation: []
	}

	const itemIds = items.filter(i => i.checked === true).map((value,key) => {
        if(value.ticketUniqueId == "" || value.ticketUniqueId === undefined || value.ticketUniqueId === null ||
            value.ticketUniqueId === "undefined" || value.ticketUniqueId === "null"
        ) {
			itemsData.noRelation.push(value)
		} else {
			itemsData.relation.push(value.ticketUniqueId)
		}
    })

	if(type == 'all' && itemsData.noRelation.length > 0) {
		dispatch(archive(itemsData.noRelation))
	}

	const data = {
		ticketIds: itemsData.relation,
		type,
	}
	return dispatch(apiCall('/api/archiveTicketsRelation', {data}))
		.then(() => dispatch(getInbox(true)))
}

/**
 * Old task generator for ticket
 * NOT USED - we use generateTaskWithRelation --> to implement multiple relations
 * NOT REMOVED UNTIL EVERY TEST IS WORKING CORRECTLY
 */
export const generateTaskFromTicket = (data) => dispatch => {
	data.users = data.users.filter(item => item.selected)

	// If the user confirmed to arhive the tickets
	if(data.confirm && data.confirm === true) {
		dispatch(archiveRelational(data.items,'all')).then(() => {
			dispatch(apiCall('/api/generateTaskFromTicket',{data: data}))
			.then(response => {
				dispatch({type: c.INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS, response})
				dispatch(getInbox(true))
				dispatch(resetStaffList())
			},(err) => dispatch({type:c.INBOX_ARCHIVE_CONVERT_TICKET_ERROR, err}))
		})
	}
	else {
		dispatch(apiCall('/api/generateTaskFromTicket',{data: data}))
		.then(response => {
			dispatch({type: c.INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS, response})
			dispatch(getInbox(true))
			dispatch(resetStaffList())
		},(err) => dispatch({type:c.INBOX_ARCHIVE_CONVERT_TICKET_ERROR, err}))
	}
}

export const forceUncheckSelectedTickets = () => dispatch => {
	dispatch({type: c.INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS})
}

export const sendTaskToUser = (data) => dispatch => {
	data.users = data.users.filter(item => item.selected)
	data.items = data.items.filter(item => item.checked)

	dispatch(apiCall('/api/sendTask',{data: data}))
	.then(response => {
		dispatch({type: c.INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS, response})
		dispatch(taskModuleListGet())
		dispatch(resetStaffList())
		dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_SEND_TASK))
	},(err) => dispatch({type:c.INBOX_ARCHIVE_CONVERT_TICKET_ERROR, err}))
}

export const setTaskReaded = (data) => dispatch => {
    dispatch(apiCall('/api/setTaskReaded', {data:data}))
    .then(response => {
        dispatch({type: c.TASK_MODULE_ITEM_READED, response})
    })
}

export const appGetNofitications = (type) => dispatch => {
	dispatch(apiCall('/getNotifications', {data: {type}}))
	.then(response => {
		dispatch({type: c.SET_APP_NOTIFICATIONS, response})
	})
}

/** TASK CREATOR ACTIONS
*****************************************************************************************/
export const taskCreatorModalToggle = () => ({
	type: c.TASK_CREATOR_MODAL_TOGGLE,
})

export const taskCreatorGenerateWithRelations = ( data ) => dispatch => {
	data.users = data.users.filter(item => item.selected)

	if( data.isArchiveConfirmation && data.isArchiveConfirmation === true ) {

		if (data.convertionType == 'outbox') {
            let outboxItemIds = data.items.map((value) =>    {
                return value.taskRelation
            })

            dispatch(apiCall('/api/generateTaskWithRelations', {data: data}))
            .then(response => {
                _archiveEmails(outboxItemIds, dispatch).then(() => {
                    dispatch({type: c.TASK_CREATOR_CONVERTION_SUCCESS, response})
                })
            }, (err) => dispatch({type:c.TASK_CREATOR_CONVERTION_FAIL, err}))
        }

        if (data.convertionType == 'inbox') {
            dispatch(apiCall('/api/generateTaskWithRelations', {data: data}))
            .then(response => {
                dispatch(taskCreatorArchiveTicketsRelational(data.items)).then(() => {
                    dispatch({type: c.TASK_CREATOR_CONVERTION_SUCCESS, response})
                })
            }, (err) => dispatch({type:c.TASK_CREATOR_CONVERTION_FAIL, err}))
        }

	}
	else {
		dispatch(apiCall('/api/generateTaskWithRelations', {data: data}))
		.then(response => {
            dispatch({type: c.TASK_CREATOR_CONVERTION_SUCCESS, response})

            if (data.convertionType === 'outbox') {
                dispatch(getOutbox(true))
            }

            if (data.convertionType === 'inbox') {
                dispatch(getInbox(true))
            }

            if (data.convertionType === 'task') {
                dispatch(taskModuleListGet())
			}

			if (data.convertionType === 'taskCreate') {
				dispatch(taskModuleListGet())
				dispatch(taskModuleModalToggle(c.TASK_MODULE_MODAL_NAME_MANAGE_TASK))
				dispatch(taskModuleFormClean('taskForm'))
			}

        }, (err) => dispatch({type:c.TASK_CREATOR_CONVERTION_FAIL, err}))
	}
}

export const taskCreatorArchiveTicketsRelational = ( taskItems ) => ( dispatch ) => {
		const itemsData = {
			noRelation: [],
			relation: []
		}

		taskItems.map((value,key) => {
        if(value.ticketMsgLink == "" || value.ticketMsgLink === undefined || value.ticketMsgLink === null ||
            value.ticketMsgLink === "undefined" || value.ticketMsgLink === "null"
        ) {
            if (value.ticketReferral !== undefined && value.ticketReferral !== null) {
                itemsData.noRelation.push(value.ticketReferral)
            }
				} else {
					itemsData.relation.push(value.ticketMsgLink)
				}
    })

		const relationalData = {
        ticketIds: itemsData.relation,
				type: 'all',
    }

    const noRelationData = {
        ticketIds: itemsData.noRelation,
				status: {archived: true},
    }

    if (itemsData.noRelation.length > 0) {
				dispatch(apiCall('/api/updateTickets', {data:noRelationData}))
    }

		return dispatch(apiCall('/api/archiveTicketsRelation', {data:relationalData}))
		.then(() => dispatch(getInbox(true)))
}

export const setAccountConfirmationHash = (hash) => {
                return {
                    type: c.SET_ACCOUNT_CONFIRMATION_HASH,
                    payload : hash
                }
}

export const createConfirmationToken = (hash) => (
	(dispatch, getState) =>
		dispatch(apiCall("/newConfirmationToken", {data: {hash}}))
)

export const validateConfirmationToken = (hash, token) => {
	return (dispatch, getState ) => {
		return dispatch(apiCall("/verifyConfirmationToken", {
			data: {
				hash, passcode: token
			}
		})).then((response) => {
			return response;
		})
	}
}

export const setAccountConfirmationStep = (step) => {
	return {
		type: c.SET_ACCOUNT_CONFIRMATION_STEP,
		payload: step
	}
}

export const cleanAccountConfirmation = () => {
	return {
		type: c.CLEAN_ACCOUNT_CONFIRMATION
	}
}

export const createNewClient = (password, hash) => {
    return (dispatch, getState) => {
        return dispatch(apiCall('/createNewClient', {
            data: {
                password, hash
            }
        } ) ).then((res) => res)
    }
}

export const checkIfClientExistApi = (hash) => {
    return (dispatch, getState) => {
        return dispatch(apiCall('/validateClientHash', {
            data: {
                hash
            }
        } ) ).then((res) => res)
    }
}

export const refreshHashAndTokenApi = (hash) =>{
    return (dispatch, getState) => {
        return dispatch(apiCall('/refreshClientHash', {
            data: {
                hash
            }
        } ) ).then(res => res)
    }
}

/************************************************************
 * Actions for Client Confirmation
************************************************************/

export const showPrintModal = (modalId, title, message, flag, payload) => ({
    type: c.SHOW_PRINT_MODAL,
    modalId,
    printModal: {
        message,
        title,
        flag,
        payload,
        result: false
    }
})

export const hidePrintModal = (modalId, result) => ({
    type: c.HIDE_PRINT_MODAL,
    modalId,
    result: result
})

/************************************************************
 * Actions for DSDOCUMENT
 ************************************************************/
/**
 *  Trigger reducer to store dsdocuments list
 * @param {*} data
 * @param {*} state
 */
export const setDSDocuments = (data, state) => {
    const {DigitalSignature} = state.app.security
    return {
        type: c.GOT_DSDOCUMENTS,
        data,
        ts: Date.now(),
    }
}

/**
 * Fetch dsdocuments from API
 * @param {*} dsdocument
 * @param {*} state
 */
export const getDSDocuments = (force) => (dispatch, getState) => {
    const {ts} = getState().DSDocuments
    if (force || (!ts || (Date.now() - ts > STALE_TIME))) {
        return dispatch(apiCall('/api/getDSDocuments'))
        .then(
            dsdocuments => dispatch(setDSDocuments(dsdocuments, getState())),
            // Ignore errors
            () => dispatch(setDSDocuments([], getState())),
        )
    }
    return Promise.resolve()
}

/**
 *  Trigger reducer to store DSDataSet
 * @param {*} data
 */
export const setDSDataSets = (data) => {
    return {
        type: c.GOT_DSDATASET,
        data
    }
}

/**
 * Fetch datasets from API
 * @param {*} dataset id
 * @param {*} state
 */
export const getDSDataSets = () => (dispatch) => {
    return dispatch(apiCall('/api/getDSDataSets', {data: {}}))
    .then(
        dataset => dispatch(setDSDataSets(dataset)),
        // Ignore errors
        () => dispatch(setDSDataSets([])),
    )
}

/**
 * Fetch teamSubgroups from API
 */
export const fetchTeamSubgroups = () => (dispatch) => {
    return dispatch(apiCall('/api/getTeamSubgroups', {data: {}}))
    .then(
        subgroups => {
            dispatch(setTeamSubgroups(subgroups))
            return subgroups
        },
        // Ignore errors
        err => {
            console.error(err)
            dispatch(setTeamSubgroups([]))
            return []
        }
    )
}

/**
 * Fetch dataset from API
 * @param {*} datasetName
 * @param {*} clientId
 * @param {*} brokerNumber
 * @param {*} language
 * @param {*} contractId
 * @param {*} claimId
 */
export const getDSDataSet = (datasetName, clientId, brokerNumber, language, contractId, claimId, brokerClient) => (dispatch) => {
    let extraParams = {}

    if (clientId) {
        extraParams.clientId = clientId
    }

    if (contractId) {
        extraParams.contractId = contractId
    }

    if (claimId) {
        extraParams.claimId = claimId
    }

    if (brokerClient) {
        extraParams.brokerClient = brokerClient
    }

    return dispatch(apiCall('/api/getDSDataSet', {data: {datasetName, brokerNumber, language, ...extraParams}}))
}

/**
 * Used to retrive a given options list from connective that we use to populate options list to selects in DSDocuments
 * @param {*} lists the list of objects that contain the parameter name and the list name we need to retrieve
 * @param {*} language the language fo the options we need
 * @returns
 */
export const getLists = (lists, language) => (dispatch) => {
	return dispatch(apiCall('/api/getLists', {data: {lists, language}}))
}

/**
 *  Trigger reducer to store DSDataSet
 * @param {*} data
 */
 export const setTeamSubgroups = (data) => {
    return {
        type: c.GOT_TEAM_SUBGROUPS,
        data
    }
}

/**
 * Fetch dataset from API
 * @param {array} formInputs The list of the DsWizard input fields, with names and values together.
 * @returns The created package instance from the server.
 */
export const upsertDSPackage = (formInputs) => (dispatch) => {

    // in case of company, force fill the First and Last name to be accepted by connective.
    // TODO find an elegant solution, ask connective for an improved service, where is not required this fields
    if(!formInputs.clientFirstName || (formInputs.clientFirstName.length === 0)){
        formInputs.clientFirstName = '\u2800'
    }

    if(!formInputs.clientLastName || (formInputs.clientLastName.length === 0)){
        formInputs.clientLastName = '\u2800'
    }

    return dispatch(apiCall('/api/upsertDSPackage', {data: {...formInputs}}))
    .then(
        (dsPackage) => {

            return dispatch(getDsDocsAndPackages(true, false, null, null, true))
            .then(()=>{
                return dsPackage
            })

        }, // TODO must got a way to avoid to load again all of the documents
        // Ignore errors
        (err) => {

            return dispatch(getDsDocsAndPackages(true, false, null, null, true)).then(()=>{
                return {} // no package received
            })

        }
    )
}

/**
 * Fetch DSPackages from API for current user
 */
export const upsertDSPackageEmailStatus = (packageId, emailId, mailOptions) => (dispatch) => {
    return dispatch(apiCall('/api/upsertDSPackageEmailHistory', {data: {packageId, emailId, mailOptions}}))
}

/**
 *  Trigger reducer to store DSDataSet
 * @param {*} data
 */
export const setDSPackages = (data) => {
    return {
        type: c.GOT_DSPACKAGES,
        data
    }
}

/**
 * Fetch DSPackages from API for current user
 */
export const getDSPackages = () => (dispatch) => {
    return dispatch(apiCall('/api/getDSPackages', {data: {}}))
    .then(
        result => dispatch(setDSPackages(result)),
        // Ignore errors
        () => dispatch(setDSPackages([])),
    )
}

/**
 *  Trigger reducer to store docs and packages
 * @param {*} data
 */
export const setDsDocsAndPackages = (data) => {
    return {
        type: c.GOT_DSDOCS_AND_PACKAGES,
        data
    }
}

/**
 * Fetch docs and packages from API for current user
 *
 * @param {*} noCache switch for use cache
 * @param {*} noLoader switch for spinner (true -> no spiner)
 * @returns
 */
export const getDsDocsAndPackages = (noCache = false, noLoader = false, alienUserId, packageId, onlyActiveTemplates = false) => (dispatch) => {
    return dispatch(apiCall('/api/getDSPackagesAndDocuments', {data: {userId: alienUserId, packageId, onlyActiveTemplates}, noLoader: noLoader, noCache: noCache}))
    .then(
        async result => {
            let resultOfSet = await dispatch(setDsDocsAndPackages(result))
            return resultOfSet.data
        },
        // Ignore errors
        (err) => {
            console.warn("getDsDocsAndPackages: err: ", err)
            return dispatch(setDsDocsAndPackages([]))
        }
    )
}

const setPaginatedPackages = (returnedData) => {
	return {
		type: c.GOT_PAGINATED_PACKAGES,
		data: {
			paginatedPackages: returnedData.packageData.data,
			totalPackageRecords: returnedData.packageData.totalRecords,
			paginationData: returnedData.paginationData,
			// indexTypeMap: returnedData.indexTypeMap
		}
	}
}

export const resetDSPackagesPaginationData = () => {
	return {
		type: c.RESET_PAGINATED_DATA,
		data:{}
	}
}

export const getPaginatedPackagesList = (data) => async (dispatch) => {
	try {
		const response = await dispatch(apiCall('api/getDsPackagesListPaginated', {data}))
		if(response) {
			const resultOfSetData = await dispatch(setPaginatedPackages({...response, paginationData: data}))
			return resultOfSetData.data
		}
		return
	} catch (error) {
        // Ignore errors
		console.warn('getPaginatedPackagesList: err: ', error)
		return dispatch(setPaginatedPackages({ paginatedPackages: [], totalPackageRecords: 0, paginationData: data}))
	}
}

export const getOneDsPackageById = (packageId) => async (dispatch) => {
	try {
		const response = await dispatch(apiCall('api/getOneDsPackageById', {data:{packageId}}))
		return response
	} catch (error) {
		return error
	}
}

/**
 * API call to get documents id's that require contract linking
 * @param {} clientId
 */

export const getDsDocsToLinkWithContract = (filterData) => (dispatch) => {
	return dispatch(apiCall('/api/getDsDocsToLinkWithContract', {data: {clientId: filterData.clientId, staffList: filterData.staffList, brokerNumbersList: filterData.brokerNumbersList}}))
	.then(
		result => result
	)
}

// TODO could be optimize by fetch and update only the affected document.
/**
 * Upsert document
 * @param {*} values
 * @returns the updated document
 */
export const upsertDSDocumentAndFetchAllData = (data) => async (dispatch) => {
	try {
		const { documentData, connectiveFormFields } = data

		let upsertDocumentReq = await dispatch(upsertDSDocument(documentData))

		//create connective form fields if there are any
		if (connectiveFormFields && connectiveFormFields.length > 0) {
			dispatch(upsertDSDocumentConnectiveFields(connectiveFormFields, documentData._id))
		}
		
		dispatch(getDsDocsAndPackages(true, false, null, null, true))

		return upsertDocumentReq
	} catch (err) {
		console.error(err)
		return dispatch(getDsDocsAndPackages(true, false, null, null, true))
	}
}

/**
 * Upsert dsDocument
 * @param {*} values
 * @returns the updated document
 */
export const upsertDSDocument = (values) => (dispatch) => {
	let upsertDocumentPromise = dispatch(apiCall('/api/upsertDSDocument', { data: { dsdocument: values } }))

	return upsertDocumentPromise
		.then((result) => {
			return Promise.resolve(result)
		})
		.catch((err) => {
			return Promise.reject(err)
		})
}

const upsertDSDocumentConnectiveFields = (connectiveFormFields, dsDocumentId) => async (dispatch) => {
	try {
		const upsertDSDocumentFormFieldsReq = await dispatch(apiCall('/api/upsertDSDocumentConnectiveFields', {data: {connectiveFormFields, dsDocumentId}} ))
		return upsertDSDocumentFormFieldsReq
	} catch (err) {
		console.error(err)
	}
}

/**
 * Upsert printable document
 * @param {*} values
 * @param {*} canvasImages
 * @returns the creted printable document
 */
export const createPrintableDocument = (values, canvasImages) => (dispatch) => {
	let upsertDocumentPromise = dispatch(apiCall('/api/createPrintableDocument', { data: { printableDocument: values, canvasImages } }))

	return upsertDocumentPromise
		.then((result) => {
			return Promise.resolve(result)
		})
		.catch((err) => {
			console.error(err)
			return Promise.reject(err)
		})
}


/**
 * Upsert more documents
 * @param {*} dsDocuments array of updates for one or more documents
 * @return the updated Documents
 */
export const updateManyDocuments = (documentIdsList, updates) => async dispatch => {
	try {
		const response = await dispatch(apiCall('/api/updateManyDocuments', {data: {documentIdsList, updates }}))
		return response
	} catch (error) {
		return error
	}
}

/**
 * Gets the signers related to a given document
 * @param {*} data
 * @returns a list of signers
 */
export const getDSStakeholders = (stakeholders, noLoader = false) => (dispatch) =>{
	const getDSStakholderPromise = dispatch(apiCall('/api/getDSStakeholders', {data: {stakeholders}, noLoader}))

	return getDSStakholderPromise
	.then(result => {
		return Promise.resolve(result)
	})
	.catch((err) => {
        return Promise.reject(err)
    })
}

export const updateDSStakeholder = (data) => (dispatch) => {
	const umpdateStakeholderRequest = dispatch(apiCall('/api/updateDSStakeholder', {data}))

	return umpdateStakeholderRequest
	.then(result => {
		return Promise.resolve(result)
	})
	.catch((err) => {
        return Promise.reject(err)
    })
}

export const getStakeholdersByPackageId = packageId => dispatch => {
	const umpdateStakeholderRequest = dispatch(apiCall('/api/getStakeholdersByPackageId', {data: {packageId}}))

	return umpdateStakeholderRequest
	.then(result => {
		return Promise.resolve(result)
	})
	.catch((err) => {
        return Promise.reject(err)
    })
}

/**
 *  Trigger reducer to store DSDocumentTemplates
 * @param {*} data
 */
export const setDSDocumentTemplates = (data) => {
    return {
        type: c.GOT_DSDOCUMENT_TEMPLATE,
        data
    }
}

/**
 * Fetch templates from API
 */
export const getDSDocumentTemplates = () => (dispatch, getState) => {
    return dispatch(apiCall('/api/getDSDocumentTemplates'))
    .then(
        result => {
			dispatch(setDSDocumentTemplates(result))
			return result
		},
        // Ignore errors
        () => dispatch(setDSDocumentTemplates([])),
    )
}

/**
 * Fetch templates from API
 */
export const getDSDocumentTemplate = (id) => (dispatch, getState) => {
    return dispatch(apiCall('/api/getDSDocumentTemplate', {data: {id}}))
}

/**
 * Fetch templates signers type list from API
 * * @param {Array} templateIdList
 */
export const getTemplatesSigners = (templateIdList) => (dispatch) => {
    return dispatch(apiCall('/api/getDSDocumentTemplatesSigners', {data: {templateIdList}}))
}



/**
 * Trigger reducer to store one dsdocument
 * @param {*} dsdocument
 * @param {*} state
 */
export const setDSDocument = (dsdocument, state) => {
    //const {DigitalSignature} = state.app.security
    return {
        type: c.GOT_DSDOCUMENT,
        dsdocument
    }
}

/**
 * Fetch one dsdocument from API
 * @param {*} dsdocument
 * @param {*} state
 */
export const getDSDocument = (id) => (dispatch, getState) => {
    return dispatch(apiCall('/api/getDSDocument', {data: {id}}))
    .then(
        dsdocument => {
            dispatch(setDSDocument(dsdocument/* , getState() */))
            return dsdocument
        },
        // Ignore errors
        () => dispatch(setDSDocument({}/* , getState() */)),
    )
}

/**
 * Fetch the configurations for digital signature system
 * @param {*} dsdocument
 * @param {*} state
 */
export const getDSDocumentConfig = (key) => (dispatch, getState) => {
    return dispatch(apiCall('/api/getDSDocumentConfig', {data:{
        key: key
    }}))
    .then(
        config => dispatch({
            type: c.GOT_DS_CONFIG,
            config
        }),
        // Ignore errors
        (err) => dispatch({
            type: c.GOT_DS_CONFIG,
            config
        }),
    )
}

/**
 * Filter DSDocuments action triggered by overview tools
 * @param {*} selectValue
 * @param {*} startDate
 * @param {*} endDate
 */
export const filterDSDocuments = (selectValue=null, startDate=null, endDate=null) => (dispatch, getState) => {
    const {DigitalSignature} = getState().app.security
    return dispatch({
        type: c.DSDOCUMENT_SET_FILTERED,
        selectValue,
        startDate,
        DigitalSignatureHelpers: DigitalSignature,
        endDate,
    })
}

/**
 * Archive all dsdocument selected
 * @param {*} itemIds
 * @param {*} dispatch
 */
const _archiveDSDocumentPackages = (itemIds = [], staffList, brokerNumbersList, dispatch) => {
        return dispatch(apiCall('/api/archiveDSDocumentPackages', {data:{
            DSDocumentIds: itemIds,
			staffList, brokerNumbersList,
            attributes: {archived: true}
        }}))
        // .then(() => dispatch(getDsDocsAndPackages(true)))
}

/**
 * Wrapper for archive all selected DSDocuments by API
 * @param {*} items
 */
export const archiveDSDocumentPackages = (items, staffList, brokerNumbersList) => (dispatch) => {
    const itemIds = items.filter(i => i.checked === true).map(i => i.id)
	return _archiveDSDocumentPackages(itemIds, staffList, brokerNumbersList, dispatch)
}

/**
 * Archive all DSDocuments
 * @param {*} items
 */
export const archiveAllDSDocumentPackages = (paginationData) => (dispatch) => {
	// const itemIds = items && items.map(i => i.id) || []
	return dispatch(apiCall('/api/archiveAllDSDocumentPackages', {data:{
		paginationData: paginationData,
		attributes: {archived: true}
	}}))
}

/**
 * Set the selected DSDocuments id to opened by the specific sub-module
 * @param {*} itemId
 */
export const setDSDocumentsOpened = (itemId) => ({
	type: c.DSDOCUMENT_ITEM_ZOOMED,
	itemId,
})

/**
 * 	Set the selected DsDocuments package id vy the specific sub-module
 * @param {*} packageId
 * @returns
 */
export const setDSDocumentsOpenedPackage = (packageId) => ({
	type: c.DSDOCUMENT_PACKAGE_ZOOMED,
	packageId
})

/**
 * Set DSDocuments SubModule (for example open the detailed page by module keyword)
 * @param {*} name
 * @param {*} subModuleZoom
 */
export const setDSDocumentsSubModule = (name, subModuleZoom) => ({
	type: c.SET_DSDOCUMENT_SUB_MODULE,
	name,
	subModuleZoom,
})

/**
 * Update DSDocumentPackage by API request
 * @param {*} data
 */
export const updateDSDocumentPackage = (data) => (dispatch) => {
    return dispatch(apiCall('/api/updateDSDocumentPackage', {data: {DSDocumentPackage: data}}))
    .then(() => dispatch(getDsDocsAndPackages(true, false, null, null, true)))
}

/**
 * Update executeFullDSDocumentWizard by API request
 * @param {*} data
 * @param {string} usersProcessFlagName optional parameter, what let you follow up the process state on server by that
 */
export const executeFullDSDocumentWizardOnServer = (packageId, usersProcessFlagName = null, noLoader = false) => (dispatch) => {
    let apiArguments =  {data: {packageId: packageId}, noLoader: noLoader}

    if (usersProcessFlagName) {
        apiArguments.data.usersProcessFlagName = usersProcessFlagName
    } else {
		apiArguments.data.usersProcessFlagName = c.USERS_PROCESS_FLAG_DEFAULT
	}

    return dispatch(apiCall('/api/executeFullDSDocumentWizard', apiArguments))
    .then((resultOfAPICall) => {

        if (!resultOfAPICall || resultOfAPICall.msg == "ERROR") {
            return Promise.reject(resultOfAPICall)
        }

        return dispatch(getDsDocsAndPackages(true, true, null, null, true))
        .then(() => resultOfAPICall)
        .catch((err) => {
            return resultOfAPICall
        })
    })
	.catch((err) => {
		return dispatch(getDsDocsAndPackages(true, true, null, null, true))
		.then(() => Promise.reject(err))
        .catch((err) => {
            //dispatch(setNotification(translate('thereWasAnErrorWhenCreatePackage') + JSON.stringify(err), 'error'))
            return Promise.reject(err)
        })
	})
}

/**
 * Set setDSWizard opened or close
 * @param {bool} name
 */
export const setDSWizard = (DSWizardOpened, moduleKey = '', mifidKey = '') => ({
	type: c.SET_DS_WIZARD,
    DSWizardOpened,
    moduleKey, mifidKey
})

/**
 * Set setOpenInvitationEditor opened or close
 * @param {bool} name
 */
export const setOpenInvitationEditor = (forceOpenInvitationEditor, moduleKey = '') => ({
	type: c.SET_DS_INVITATION_EDITOR,
    forceOpenInvitationEditor,
    moduleKey
})

/**
 * Set forceOpenInvitationFromTicket opened or close
 * @param {bool} name
 */
export const setOpenInvitationEditorFromTicket = (forceOpenInvitationFromTicket, moduleKey = '') => ({
	type: c.SET_DS_INVITATION_EDITOR_FROM_TICKET,
    forceOpenInvitationFromTicket,
    moduleKey
})

/**
 * Will send an reminder to client
 */
export const resendClientRemainder = (packageId, stakeholderId = null) => (dispatch) => {
    return dispatch(apiCall('/api/resendClientRemainder', {data: {packageId: packageId, stakeholderId}}))
	.catch((err) => {
		console.warn(err)
		return err
	})
}

/**
 * Generate PDF and return the lin toward it.
 * @param {*} data
 */
export const getHalfFilledPdfForPrint = (dsdocumentId) => (dispatch) => {
    return dispatch(apiCall('/api/getHalfFilledPdfForPrint', {dsdocumentId: dsdocumentId}))
}

/**
 * Generate PDF and return the lin toward it.
 * @param {*} data
 */
export const getFilledPrintablePdfDocument = (documentId) => (dispatch) => {
    return dispatch(apiCall('/api/getFilledPrintablePdfDocument', {printableDocumentId: documentId}))
}

/**
 * Get updatable Packages List by API request
 * @param {*} data
 */
export const getUpdatablePackagesList = () => (dispatch) => {
    return dispatch(apiCall('/api/getUpdatablePackagesList', {data: {}}))
}

/**
 * Update Packages List by API request
 * @param {*} data
 */
export const updatePackagesFromConnective = (idList) => (dispatch) => {
    return dispatch(apiCall('/api/updatePackagesFromConnective', {data: {idList}, noLoader: true}))
}

/**
 * Update Packages List by API request
 * @param {*} data
 */
export const uploadDocumentIfItIsSigned = (packageId, documentId) => (dispatch) => {
    return dispatch(apiCall('/api/uploadDocumentIfItIsSigned', {data: {packageId, documentId}, noLoader: false}))
    .catch((err) => {
        return Promise.resolve(err)
    })
}

/**
 * Update Packages List by API request
 * @param {*} data
 */
export const uploadReadyDocuments = (packageId) => (dispatch) => {
    return dispatch(apiCall('/api/uploadReadyDocuments', {data: {packageId}, noLoader: false}))
    .catch((err) => {
        return Promise.resolve(err)
    })
}

/************************************************************
 * End of DSDocuments
 */

/************************************************************
 * START Actions for emailServer *
 ******************************/

 /**
  * This function call the save API for email server configs
  * @param {object} data - record information, with different props because of security
  */
export const saveEmailServer = (data) => dispatch => (
    dispatch(apiCall(`/api/saveEmailServer`, {data}))
    .catch((err) => dispatch(setNotification('Could not save the email server configuration!' + JSON.stringify(err), 'error')))
)

/**
 * This function call the delete API for email server configs
 * @param {string} id - the id of the configuration record
 */
export const deleteEmailServer = (id) => dispatch => (
    dispatch(apiCall(`/api/deleteEmailServer`, {data:{id}}))
    .catch((err) => dispatch(setNotification('Could not delete the email server configuration!' + JSON.stringify(err), 'error')))
)

/**
 * This function call the load API for email server configs.
 * @param {string} emailAddress - must be a valid email address
 */
export const loadEmailServer = (emailAddress) => dispatch => (
    dispatch(apiCall(`/api/loadEmailServer`, {data: {emailAddress: emailAddress}}))
    .then((result) => {

        if (!result || result.error || !result._id) {
            return Promise.reject(null)
        }

        result.autotls = nesProp.get(result, "autotls") ? true : false
        result.auth_user = nesProp.get(result, "auth.user")
        result.auth_password = nesProp.get(result, "auth.password")
        result.tls_rejectUnauthorized = nesProp.get(result, "tls.rejectUnauthorized")

        return result
    })
    //.catch((err) => err)
)

/**
 * Send the form information without saving it, and an email-address to test the settings. The email will be sent immediately.
 * @param {object} data - the form values (server configurations), and the recipient email-address to test.
 */
export const sendTestEmailWithConfig = (data) => dispatch => (
    dispatch(apiCall(`/api/testEmailServer`, {data}))
	.catch((err) => {
		// dispatch(setNotification('Could not test the email server configuration!' + JSON.stringify(err), 'error'))
		console.warn("Error output of server response: ", err)

		return Promise.reject({ serverResponse: {
				...err,
				body: err ? err.body : null,
				bodyUsed: err ? err.bodyUsed : null,
				headers: err ? err.headers : null,
				ok: err ? err.ok : null,
				redirected: err ? err.redirected : null,
				status: err ? err.status : null,
				statusText: err ? err.statusText : null,
				type: err ? err.type : null,
				url: err ? err.url : null
			}
		})

	})
)

// following commented code are for testing...

/* eturn new Promise((resolve, reject)=>{
	let expiredWait = false
	let setExpiredWaitTrue = () => {
		console.log(" FORCE STOP WAITING ")
		expiredWait = true
	}
	setTimeout(setExpiredWaitTrue, 3000)

	return waitFor(
		()=> (err && (Object.keys(err).length > 0)) || expiredWait,
		reject({
			serverResponse: JSON.parse(JSON.stringify(err))
		})
	)

})

const waitFor = (condition, callback) => {
    if(!condition()) {
        console.log('waiting')
        setTimeout(waitFor.bind(null, condition, callback), 100)
    } else {
        console.log('done')
        return callback()
    }
} */
/* END Actions for emailServer
 ************************************************************/


/************************************************************
 * START Actions for emailServer *
 ******************************/
export const reportError = data => dispatch =>  (
	dispatch(apiCall(`/browserError`, {data}))
	.then(res => res)
	.catch((err) => {
		console.warn("Error output of server response: ", err)
	})
)

/*****************************
 * END Actions for emailServer
 ****************************/

/**********************************
 * START Actions for Client Notes *
 **********************************/

export const saveClinetNote = (data) => dispatch => (
    dispatch(apiCall(`/data/saveClientNote`, {data}))
	.then(res =>res)
    .catch((err) => dispatch(setNotification('Could not save the clientNote!' + JSON.stringify(err), 'error')))
)

export const getClientNote = (data) => dispatch => (
	dispatch(apiCall('/data/getClientNote', {data}))
	.then(res => res)
    .catch((err) => dispatch(setNotification('Could not get clientNote!' + JSON.stringify(err), 'error')))
)

export const deleteClientNote = (data) => dispatch => (
	dispatch(apiCall(`/data/deleteClientNote`, {data}))
	.then(res => res)
    .catch((err) => dispatch(setNotification('Could not delete clientNote!' + JSON.stringify(err), 'error')))
)

export const showLoader = () => dispatch => {
	dispatch({type: c.SHOW_LOADER})
}

export const hideLoader = () => dispatch => {
	dispatch({type: c.HIDE_LOADER})
}

/**
 * API call to update flag for user process from server in store.
 * This update the store for
 * @param {string} flagName
 */
export const fetchUsersProcessFlag = (flagName, referenceId) => (dispatch, getState) => {
    const {UsersProcessFlag} = getState()
    const currentFlag = nesProp.get(UsersProcessFlag, referenceId)
    const isActiveProcess = nesProp.get(currentFlag, "isActive")

    return dispatch(apiCall('/api/getUsersProcessFlag', {data: {flagName, referenceId}}))
    .then((usersProcessFlagRecord) => {

        // if (usersProcessFlagRecord) {
            // update in store the feched information about the users process flag
            dispatch({
                type: c.USERS_PROCESS_FLAG_ARRIVED,
                referenceId,
                record: usersProcessFlagRecord
            })
        // }

        return isActiveProcess
    })
}

/**
 * Stop to check the server
 * @param {*} flagName
 * @param {*} referenceId
 * @returns
 */
export const stopUsersProcessFlagWatch = (flagName, referenceId) => (dispatch, getState) => {
    return dispatch({
        type: c.USERS_PROCESS_FLAG_STOP_WATCH,
        referenceId,
    })
}

/**
 * Start to check the server after process
 * @param {String} flagName The name to help to assign the current progress in database
 * @param {String} referenceId The reference ID (unique) to help to assign the current progress in database
 * @param {Numeric} checkpointCount the number of the stations of the progress
 * @returns
 */
export const startUsersProcessFlagWatch = (flagName, referenceId, checkpointCount) => (dispatch, getState) => {
    return dispatch({
        type: c.USERS_PROCESS_FLAG_START_WATCH,
        referenceId,
        checkpointCount
    })
}


/**
 * Remove the process reference from store
 * @param {*} flagName
 * @param {*} referenceId
 * @returns
 */
 export const removeUsersProcessFlagWatch = (flagName, referenceId) => (dispatch, getState) => {
    return dispatch({
        type: c.USERS_PROCESS_FLAG_REMOVE,
        referenceId,
    })
}

/**
 * This function do repeated call recursively to check a process status and update it in the redux store.
 * Can be stopped by dispatching stopUsersProcessFlagWatch
 * @param {*} flagName
 * @param {*} referenceId
 */
export const doUsersProcessFlagWatch = (flagName, referenceId) => (dispatch, getState) => {
    setTimeout(async () => {
        let isActiveProcess = await dispatch(fetchUsersProcessFlag(flagName, referenceId))

        // exiting condition from recursive operation
        if(isActiveProcess) {
            dispatch(doUsersProcessFlagWatch(flagName, referenceId))
        }
    }, 1000)
}

/**
 * API call to get image list about a pdf document.
 * @param {string} dsdocumentId
 */
export const getImageListAboutPDF = (dsDocumentId) => (dispatch, getState) => {
    return dispatch(apiCall('/api/documentToImagesInfo/'+dsDocumentId))
}

/* This action can open or close a general information popup from any of the modules.
 * Th rendering is inserted in the main part of rendering.
 * @param {*} isOpened
 * @param {*} msg
 * @returns
 */
export const setVersionCheckNotification = (isOpened, title = '', msg = '') => ({
	type: c.VERSION_CHECK_NOTIFICATION_SET,
	title,
	msg,
	isOpened,
})

/**
 * API call to get documents size list
 * @param {array} generatedDocs - optional [templateId, templateId, templateId, ...]
 * @param {array} oracleDocs - optional [ {oracleDocumentId: <string>, oracleDocumentType: <string>}, ... ]
 * @param {array} uploadedDocs - optional [temporaryFileRecordId, temporaryFileRecordId, temporaryFileRecordId, ...]
 * @returns is the same structure as the call arguments but contains a "size prop in plus at the records"
 */
export const fetchDsDocumentSizeList = (generatedDocs = null, oracleDocs = null, uploadedDocs = null) => (dispatch, getState) => {
    let data = {}
    if (oracleDocs) {
        data.DS_ORIGIN_ORACLE = oracleDocs
    }
    if (generatedDocs) {
        data.DS_ORIGIN_GENERATED = generatedDocs
    }
    if (uploadedDocs) {
        data.DS_ORIGIN_LOCAL_UPLOAD = uploadedDocs
    }

    return dispatch(apiCall('/utilities/countAssetSizes/', {data}))
}

/**
 *
 * @param {*} tempFileId
 * @returns
 */
export const removeTemporaryUpload = (tempFileId) => (dispatch, getState) => {
    return dispatch(apiCall('/api/removeTemporaryUpload', {data: {ids : tempFileId}}))
}

/**
 *
 * @returns {claimsAvailable: boolean, count: number}
 */
export const getDSDocumentTemplateClaimsAvailability = () => (dispatch, getState) => {
    return dispatch(apiCall('/api/getDSDocumentTemplateClaimsAvailability'))
}

/**
 *
 * @returns {claimsAvailable: boolean, count: number}
 */
export const recreateDsPackage = (packageId) => (dispatch, getState) => {
    return dispatch(apiCall(`/api/dsSystem/package/${packageId}/recreate`))
}

/**
 *
 * @returns {pckage: obj}
 */
export const handlePackageAfterPrint = (packageId) => (dispatch, getState) => {
    return dispatch(apiCall(`/api/dsSystem/package/${packageId}/handlePackageAfterPrint`))
}

/**********************************
 * START Actions for search Broker info *
 **********************************/

export const getBrokerInfo = (brokerNumber) => async (dispatch, getState) => {
	try {
		const res = await dispatch(apiCall('data/getBrokerInfo', {data:{brokerNumber}}))
		if (res && res.brokerNumber) {

			//in this response Ann returns the aml translation number instead of "nl" of "fr" for language so to use it we need to
			// turn it in values we can use so far there are 3 options 1 : Nl 2: FR; 3: EN
			switch (res.main.language) {
				case '1':
					res.main.language = 'nl'
					break;
				case '2':
					res.main.language = 'fr'
					break;
				case '3':
					res.main.language = 'en'
					break;
			
				default:
					res.main.language = 'nl'
					break;
			}

			// add this broker data to existing brokers list
			const brokersCopy = {...getState().office.brokers}
			const accountManagers = {...getState().office.accountManagers}
			brokersCopy[res.brokerNumber] = res
			dispatch(setOfficeData(brokersCopy, accountManagers))
            dispatch(setBrNr(res.brokerNumber))
			return res
		}
	} catch (error) {
		dispatch(setBrNr(''))
		console.warn('Error calling getBrokerInfo: ', error);
		return error
	}
}

export const createLocalUploadFilesFromAttachments = (files) => async (dispatch) => {
	try {
		const createLocalsResponse = await dispatch(apiCall('api/createLocalUploadFilesFromAttachments', {data: {files}}))
		return createLocalsResponse 
	} catch (error) {
		console.warn('create local upload files from template attachments fail: ', error);
	}
}


// ================================
// #region Version 10.0 Digital Claim wizard
// ================================

export const getProductsAndRisksRequest = (contractId, claimDate) => async (dispatch) => {
	try {
		const getProductsAndRisksRes = await dispatch(apiCall('data/getProductsAndRisks', { data: { contractId, claimDate } }))
		return getProductsAndRisksRes
	} catch (error) {
		console.warn('getProductsAndRisks error ::: ', error);
	}
}

export const getDocumentationRequest = (qualificationNumber, subQualificationNumber) => async (dispatch) => {
	try {
		const getDocumentationRes = await dispatch(apiCall('data/getDocumentation', { data: { qualificationNumber, subQualificationNumber } }))
		if(getDocumentationRes) {
			dispatch(setDocumentation(getDocumentationRes)) 
		}
	} catch (error) {
		console.warn('getDocumentation error ::: ', error);
	}
}

const setDocumentation = ({documents, involvedParties, optionalParties}) => dispatch => {
	return dispatch({
		type: c.SET_CLAIM_WIZARD_DOCUMENTATION,
		documents, involvedParties, optionalParties
	})
}

export const getQualificationsRequest = (branch, contractId, contractIdHist) => async (dispatch) => {
	try {
		const getQualificationsRes = await dispatch(apiCall('data/getQualifications', { data: { branch, contractId, contractIdHist } }))
		return getQualificationsRes
	} catch (error) {
		console.warn('getQualifications error ::: ', error);
		return error
	}
}

export const createClaim = (args) => async (dispatch) => {
	try {
		return dispatch(apiCall('data/createClaim', { data: { ...args } }))
	} catch (error) {
		console.warn('createClaim error ::: ', error);
		return error
	}
}

/**
 * Updates contact parameters for claimWizard step one 
 * Tese parameters are updated both in Oracle and Mongo
 * @param {*} args list of arguments defined by client that are alowed to be updated
 * @returns 
 */
export const updateClaimContact = (args) => async (dispatch) => {
	try {
		return await dispatch(apiCall('data/updateClaimContact', { data: { ...args } }))
	} catch (error) {
		console.warn('updateClaimContact error ::: ', error);
		return error
	}
}

/**
 * A general update call that will actualizerd the claimWizard package record in mongo only
 * Usage:
 * 1.To update dsDocumetPackage list in mongo after creating a new dsPackage in claimWizard
 * @param {*} args 
 * @returns 
 */
export const updateClaimWizardPackage = (claimWizardPackageId, args) => async (dispatch) => {
	try {
		const updateResponse = await dispatch(apiCall('data/updateClaimWizardPackage', { data: { claimWizardPackageId, argsToUpdate: args } }))
		// update list of dsDocumentPackages in store if response is successful

		if(updateResponse) {
			return dispatch(setDocumentsForStepThree(claimWizardPackageId, updateResponse))
		}
		return updateResponse

	} catch (error) {
		console.warn('updateClaimWizardPackage error ::: ', error);
		return error
	}
}

export const updateClaimStatus = (args) => async (dispatch) => {
	try {
		return await dispatch(apiCall('data/updateClaimStatus', { data: { ...args } }))
	} catch (error) {
		console.warn('updateClaimStatus error ::: ', error);
		return error
	}
}

export const updateInvolvedParties = (args) => async (dispatch) => {
	try {
		return await dispatch(apiCall('data/updateInvolvedParties', { data: { ...args } }))
	} catch (error) {
		console.warn('updateInvolvedParties error ::: ', error);
		return error
	}
}

export const getClaimWizardPackage = (args) => async (dispatch) => {
	try {
		const claimDataRes = await dispatch(apiCall('data/getClaimWizardPackage', { data: { ...args } }))
		if(claimDataRes) {
			dispatch(setClaimData(claimDataRes))
		}
		return claimDataRes
	} catch (error) {
		console.warn('getClaimWizardPackage error ::: ', error)
		return null
	}
}

export const fetchAllClaimWizardPackages = (data) => async (dispatch) => {
    try {
        const response = await dispatch(transactionCall('/data/claims', { data: trimObject(data), noCache: true, noLoader: true }))
        await dispatch(setAllClaimWizardPackages(response))

        return response
    } catch (error) { 
		console.warn('Error fetching all claim wizard packages:', error)
        return error
    }
}

export const initializeClientProfileFromPackage = (claimWizardPackages, clientId, formType) => (dispatch) => {
    const clientPackage = claimWizardPackages.find(pkg => pkg.clientId === clientId);

    if (clientPackage && clientPackage.clientData) {
        dispatch(initializeProfileForm(clientPackage.clientData, clientId, formType));
    } else {
        console.error(`Client with ID ${clientId} not found in claimWizardPackages.`);
    }
};

/**
 * Set claim data after claim creation and claim contact update these will also require to navigate to step 2
 * When setting initial claim data for existing claim default step will be 1
 * @param {*} claimData 
 * @param {*} wizardStep 
 * @returns 
 */
const setClaimData = (claimData, wizardStep = '1') => dispatch => {
	return dispatch({
		type: c.SET_CLAIM_WIZARD_DATA,
		claimData
	})
}

export const toggleLegalAid = (isLegalAid) => dispatch => {
	return dispatch({
		type: c.TOGGLE_LEGAL_AID,
		isLegalAid
	})
}

export const resetClaimWizard = () => dispatch => {
	return dispatch({
		type: c.RESET_CLAIM_WIZARD
	})
}

export const setClaimWizardStep = (wizardStep) => dispatch => {
	return dispatch({
		type: c.SET_CLAIM_WIZARD_STEP,
		wizardStep
	})
}

export const addOptionalParty = () => dispatch => {
	return dispatch({
		type: c.ADD_OPTIONAL_PARTY
	})
}

export const updatePartyField = (value, partyId, field) => dispatch => {
	return dispatch({
		type: c.UPDATE_PARTY_FIELD,
		partyId, value, field
	})
}

export const removeOptionalParty = (partyId) => dispatch => {
	return dispatch({
		type: c.REMOVE_OPTIONAL_PARTY,
		partyId
	})
}

export const setDocumentsForStepThree = (claimPackageId, claimWizardPackage) => async dispatch => {
	try {
		// get dsDocumentTemplates available on claim wizard
		const dsDocumentTemplates = await dispatch(apiCall('/api/getDSDocumentTemplates', { data: { availableOnModules: ['DS_MODULE_CLAIM_WIZARD'] } }))
		//  API to return the documents for step 3 storred in the mongo db
		const claimWizardDocuments = await dispatch(apiCall('data/getClaimWizardDocuments', { data: { claimPackageId } }))
		const dsDocumentPackages = await dispatch(apiCall('data/getClaimWizardDsPackages', { data: { dsPackageIds: claimWizardPackage.dsPackages.map(onePackage => onePackage.dsPackage) } }))
		return dispatch({
			type: c.SET_DOCUMENTS_FOR_STEP_THREE,
			claimWizardDocuments, dsDocumentTemplates, dsDocumentPackages
		})
	} catch (error) {
		console.warn('setDocumentsForStepThree error ::: ', error);

	}

}

export const setAlternativeDocType = (alternativeSelectionId, docType) => dispatch => {
	return dispatch({
		type: c.SET_ALTERNATIVE_DOC_TYPE,
		alternativeSelectionId, docType
	})
}

export const addClaimWizardOptionalDocument = () => dispatch => {
	return dispatch({
		type: c.ADD_OPTIONAL_CLAIM_DOCUMENT
	})
}

export const updateClaimWizardOptionalDocument = (docType, tempId) => dispatch => {
	return dispatch({
		type: c.UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT,
		docType, tempId
	})
}

export const removeClaimWizardOptionalDocument = (tempId) => dispatch => {
	return dispatch({
		type: c.REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT,
		tempId
	})
}

export const addFilesToClaimWizardState = (files) => dispatch => {
	return dispatch({
		type: c.ADD_FILES_TO_CLAIM_WIZARD,
		files
	})
}

export const removeDocumentFileFromClaimWizard = (fileId) => dispatch => {
	return dispatch({
		type: c.REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD,
		fileId
	})
}

export const uploadClaimWizardDocuments = (files, claimId, claimWizardPackageId) => async (dispatch, getState) => {
	try {
		//must have a default group type for create upload when we upload documents from claimWizard
		const defaultGroupType = '1'
		const createUploadRes = await dispatch(apiCall('api/createUpload', { data: { type: defaultGroupType, claimId } }))
		if (!createUploadRes.uploadId) {
			console.warn('uploadClaimWizardDocuments error ::: ', createUploadRes);
			// if there is an error in create upload create a wizrdError param in the state and add this error for step 3
			dispatch(updateFileUploadStatus(file.fileId, 'error', translate('unknownErrorOccurred'))) 
			return { error: translate('unknownErrorOccurred')}
		}
		
		const uploadPromises = []
		for (const file of files) {
			if (file.name) {
				// if file is from dsPackage skip it
				if(file.dsPackageStatus) {
					continue
				}
				// if file is already uploaded or has an error skip it
				if (file.uploaded || file.error) {
					console.warn('file already uploaded or error ::: ', file);
					continue
				}

				// create a promise for each file upload
				const oneFilePromise = new Promise((resolveFileUpload, rejectFileUpload) => {
					let fData
					fData = new FormData()
					fData.append('uploadId', createUploadRes.uploadId)
					fData.append('type', file.docType)
					fData.append('comment', file.name)
					fData.append('originalFileName', file.name)
					fData.append('date', serverDateFormat(file.lastModified))

					fData.append('file', file.file)

					const request = new XMLHttpRequest()

					request.onreadystatechange = () => {
						if (request.readyState === 4) {
							// EXIT POINT status not 200
							if (request.status !== 200) {
								dispatch(updateFileUploadStatus(file.fileId, 'failed', translate('unknownErrorOccurred'))) 
								// rejecting promise of this individual upload
								return rejectFileUpload({ filetype: type.id, fileId: file.fileId, error: "request.status !== 200" })
							}

							// status is 200
							try {
								const resp = JSON.parse(request.response)
								let errorFound = nesProp.get(resp, "success.error") || nesProp.get(resp, "error")

								if (errorFound) {
									let statusText
									if (nesProp.get(resp, "success.error") === "conversionFail") {
										statusText = translate("unknownErrorOccurred")
									} else {
										statusText = nesProp.get(resp, "success.error") ||
											translate("unknownErrorOccurred") + ": " + nesProp.get(resp, "message") ||
											translate("unknownErrorOccurred") + ": " + JSON.stringify(request.responseText)
									}
									dispatch(updateFileUploadStatus(file.fileId, 'failed', statusText)) 

									// rejecting promise of this individual upload
									return rejectFileUpload({ filetype: type.id, fileId: file.fileId, error: statusText })
								} else {
									dispatch(updateFileUploadStatus(file.fileId, 'success')) 
									
									// resolving promise of this individual upload
									return resolveFileUpload({
										filetype: file.docType,
										fileId: file.fileId,
										response: nesProp.get(resp, "success")
									})
								}
							} catch (err) {
								let statusText = nesProp.get(request, "response.message") || JSON.stringify(request.responseText)
								const error = {
									status: 'error',
									data: translate("unknownErrorOccurred") + ": " + statusText,
								}
								dispatch(updateFileUploadStatus(file.fileId, 'error', error.data)) 

								// rejecting promise of this individual upload
								return rejectFileUpload({ filetype: file.docType, fileId: file.fileId, error })
							}
						}
					}

					request.open('POST', '/api/upload', true)
					request.setRequestHeader('x-csrf-token', translate('csrfclienttoken'))
					request.send(fData)
				})

				// collect upload promises
				uploadPromises.push(oneFilePromise)
			}
		}

		const allUploadResult = Promise.allSettled(uploadPromises)
			.then(async (results) => {

				for (const oneResult of results) {
					if (oneResult.status === 'fulfilled') {
						const fileData = getState().claimWizard.documentFiles.find(onFile => oneResult.value.fileId === onFile.fileId)

						const args = {
							name: fileData.name,
							docType: fileData.docType,
							mainDocType: fileData.mainDocType,
							alternativeId: fileData.alternativeId,
							uploadId: oneResult.value.response.uploadImageId,
							fileSize: fileData.size,
							uploaded: fileData.uploaded,
							claimPackage: claimWizardPackageId
						}
						const createClaimDocRes = await dispatch(apiCall('data/createClaimWizardDocument', { data: { ...args } }))
					}
				}
				return results
			})
			.catch((err) => {
				console.warn("Upload files ", err)
				return err
			})
		// create mongo records for uploaded files

		return allUploadResult
	} catch (error) {
		console.warn('uploadClaimWizardDocument error ::: ', error);
		return error
	}
}

const updateFileUploadStatus = (fileId, status, message) => dispatch => {
	return dispatch({
		type: c.UPDATE_FILE_UPLOAD_STATUS,
		fileId, status, message
	})
}

export const setAllClaimWizardPackages = (claimWizardPackages) => (dispatch) => {
    return dispatch({
        type: c.SET_ALL_CLAIMWIZARD_PACKAGES,
        claimWizardPackages
    })
}

export const clearClaimWizardPackages = () => (dispatch) => {
    return dispatch({
        type: c.CLEAR_CLAIM_WIZARD_PACKAGES
    });
}

export const claimConfirmation = (claimId) => dispath => {
	return  dispath(apiCall('data/claimConfirmation', { data: { claimId } }))
}

export const updateClaimComment = (claimId, comment) => dispath => {
	return  dispath(apiCall('data/updateClaimComment', { data: { claimId, comment } }))
}

export const setHasSubQualifications = (hasSubQualifications) => dispatch => {
	return dispatch({
		type: c.SET_CLAIM_WIZARD_SUBQUALIFICATION,
		hasSubQualifications: hasSubQualifications
	})
}

export const navigateToClientClaims = (clientId, claimId, claimNumber) => dispatch => {
    dispatch(setAppModule(c.CLIENTS, clientId))
    dispatch(setClientSubModule('claims', { claimNumber }))
    dispatch(setOpenedSubmenu(claimId))
}

export const navigateToClientContracts = (clientId, contractId) => dispatch => {
    dispatch(setAppModule(c.CLIENTS, clientId))
    dispatch(setOpenedSubmenu(contractId))
    dispatch(setClientSubModule('contracts'))
}

// #endregion


// WEBPACK FOOTER //
// ./state/actions/index.js